
























import { Component, Prop, Vue } from "vue-property-decorator";
import Header from "@/commonComponents/header/header.vue";
import CanvasWindow from "./canvasWindow/canvasWindow_m.vue";
import TopController from "./topController/topController.vue";
// import ObjectListController from './objectListController/objectListController.vue';
import SubController from "./subController/subController.vue";
import RightController from "./rightController/rightController.vue";
import FileOpen from "@/commonComponents/fileOpen/fileOpen.vue";
import ContextMenu from "@/commonComponents/contextMenu/contextMenu.vue";
import DesignRenderer from "./designRenderer/designRenderer.vue";
import AddPage from "./addPageModal/addPageModal.vue";
import LoadingScreen from "@/commonComponents/loadingScreen/loadingScreen.vue"
import Tutorial from "../tutorial/tutorial.vue";
import License from "../top2/mainContents/license/license.vue";

import PopupController from "./_mobile/popupController/popupController.vue";

import * as def from "@/definitions";
import { Const } from '@/const'
import { ShortcutManager } from "@/model/shortcutManager/shortcutManager";
import { ClipboardManager } from "@/model/clipboardManager/clipboardManager";
// TODO document2
import { Document } from "@/model/document2/document";
import { Design } from "@/model/document2/page/surface/design/design";
import { Layer } from "@/model/document2/page/surface/design/layer/layer";
import { GroupLayer } from "@/model/document2/page/surface/design/layer/groupLayer";
import { LineLayer } from "@/model/document2/page/surface/design/layer/lineLayer";
import { CurveLayer } from "@/model/document2/page/surface/design/layer/curveLayer";
import { RectangleLayer } from "@/model/document2/page/surface/design/layer/rectangleLayer";
import { CircleLayer } from "@/model/document2/page/surface/design/layer/circleLayer";
import { D3TextLayer } from "@/model/document2/page/surface/design/layer/d3TextLayer"
import { DateTextLayer } from "@/model/document2/page/surface/design/layer/dateTextLayer"
import { NumberLayer } from "@/model/document2/page/surface/design/layer/numberLayer"
import { PolygonLayer } from "@/model/document2/page/surface/design/layer/polygonLayer";
import { TextLayer } from "@/model/document2/page/surface/design/layer/textLayer";
import { ExTextLayer } from "@/model/document2/page/surface/design/layer/exTextLayer";
import { PlainTextLayer } from "@/model/document2/page/surface/design/layer/plainTextLayer";
import { CircleTextLayer } from "@/model/document2/page/surface/design/layer/circleTextLayer";
import { PatternBaseLayer } from "@/model/document2/page/surface/design/layer/patternBaseLayer";
import { ImageLayer } from "@/model/document2/page/surface/design/layer/imageLayer";
import { TableLayer } from "@/model/document2/page/surface/design/layer/tableLayer";
import { BarcodeLayer } from "@/model/document2/page/surface/design/layer/barcodeLayer";
import { QRcodeLayer } from "@/model/document2/page/surface/design/layer/qrcodeLayer";
import { UndoRedoManager } from "@/utilityModels/undoRedoManager";
import { TextInfo } from "@/utilityModels/textInfo";
import { ColorConstruct } from "@/utilityModels/colorConstruct";
import { Rectangle } from "@/utilityModels/rectangle";
import { Vector2 } from "@/utilityModels/vector2";
import { ProfileData } from "@/utilityModels/profileData";

// Command
import { NewLayerCommand } from "@/commands/newLayerCommand";
import { InsertLayerCommand } from "@/commands/insertLayerCommand";
import { TransformLayerCommand } from "@/commands/transformLayerCommand";
import { ChangeLayerPropertyCommand } from "@/commands/changeLayerPropertyCommand";
import { DeleteLayerCommand } from "@/commands/deleteLayerCommand";
import { MoveCurveControlPointCommand } from "@/commands/moveCurveControlPointCommand";
import { MovePolygonControlPointCommand } from "@/commands/movePolygonControlPointCommand";
import { ApplyPolygonControlPointsCommand } from "@/commands/applyPolygonControlPointsCommand";
import { NewDesignCommand } from "@/commands/newDesignCommand";
import { ChangePlainTextLayerWholeTextInfoCommand } from "@/commands/changePlainTextLayerWholeTextInfoCommand";
import { ChangePlainTextLayerRangeTextInfoCommand } from "@/commands/changePlainTextLayerRangeTextInfoCommand";
import { ChangeTextCommand } from "@/commands/changeTextCommand";
import { DuplicateLayerCommand } from "@/commands/duplicateLayerCommand";
import { AddControlPointToCurveCommand } from "@/commands/addControlPointToCurveCommand";
import { RemoveControlPointFromCurveCommand } from "@/commands/removeControlPointFromCurveCommand";
import { RotateDesignCommand } from "@/commands/rotateDesignCommand";
import { AddGradationOfPatternCommand } from "@/commands/addGradationOfPatternCommand";
import { RemoveGradationOfPatternCommand } from "@/commands/removeGradationOfPatternCommand";
import { ChangeGradationColorOfPatternCommand } from "@/commands/changeGradationColorOfPatternCommand";
import { ChangeGradationPositionOfPatternCommand } from "@/commands/changeGradationPositionOfPatternCommand";
import { ChangeTableCellInfoCommand } from "@/commands/changeTableCellInfoCommand";
import { AddTableCellCommand } from "@/commands/addTableCellCommand";
import { DeleteTableCellCommand } from "@/commands/deleteTableCellCommand";
import { NewPageCommand } from '@/commands/newPageCommand';
import { DuplicateLayerToSurfaceCommand } from '@/commands/duplicateLayerToSurfaceCommand'
import { InsertProfileCommand } from '@/commands/insertProfileCommand';
import { AddLayerCommand } from '@/commands/addLayerCommand';
import { ReplaceTemplateCommand } from '@/commands/replaceTemplateCommand';

import { ApplicationState } from "@/model/applicationState/applicationState";

// Helper
import { FileHelper } from "@/helper/fileHelper";
import { NameHelper } from '@/helper/nameHelper';
import { MathHelper } from '@/helper/mathHelper';
import { ArrayHelper } from '@/helper/arrayHelper';
import { PathHelper } from '@/helper/pathHelper';
import { ImageHelper } from '@/helper/imageHelper';
import { VectorImageLayer } from '@/model/document2/page/surface/design/layer/vectorImageLayer';
import { RasterImageLayer } from '@/model/document2/page/surface/design/layer/rasterImageLayer';
import { CookieHelper } from "@/helper/cookieHelper"
import { DateHelper } from "@/helper/dateHelper"
import { DocumentHelper } from '@/helper/documentHelper';
import { DebugHelper } from "@/helper/debugHelper";
import { UuidHelper } from '@/helper/uuidHelper';
import { FontHelper } from '@/helper/fontHelper';
import { UserAgentHelper } from '@/helper/userAgentHelper';
import { RequestHelper } from '@/helper/requestHelper';
import { EncryptionHelper } from '@/helper/encryptionHelper';
import { NativeHelper } from '@/helper/nativeHelper';
import { InitializeHelper } from '@/helper/initializeHelper';

import WebFont from "webfontloader";

@Component({
  components: {
    Header,
    CanvasWindow,
    TopController,
    SubController,
    RightController,
    FileOpen,
    ContextMenu,
    DesignRenderer,
    AddPage,
    LoadingScreen,
    Tutorial,
    License,
    PopupController
  }
})

//******************************************//
//**************** モバイル用 ****************//
//******************************************//
export default class Edit extends Vue
{
    // ドキュメントのロード終了フラグ
    // モバイルではこのフラグがオンになるまでは表示させない
    private isLoadedDocument = false;

    // モバイル用コントローラ
    private popupControllerType = "none";

    // フォントロードフラグ
    private isFontLoaded = false;

    //ローディングフラグ
    // private loading = false

    // チュートリアル表示フラグ
    isTutorial = false;
    // 使用規約許諾
    isLicense = false;

    // ショートカット無効フラグ
    // inputModeとは独立してショートカットを無効にする
    private isShorcutDisabled = false;

    private get paperInfoText() { return DocumentHelper.getPaperInfoText(this.currentDocument); }

    // レンダリング中フラグ
    private isRendering : boolean = false;

    // デザインレンダリングフラグ
    private isRenderingDesign : boolean = false;
    // レンダリングクオリティ(pt -> pxに乗ずる値)
    private renderingQuality : number = 1;
    // レンダリング中レイヤーの描画範囲でクリップする
    private renderingClipLayer : boolean = false;
    // レンダリング開始
    private startRendering(quality : number, isClipLayer : boolean)
    {
        this.isRenderingDesign = true;
        this.renderingQuality = quality;
        this.renderingClipLayer = isClipLayer;
    }
    // レンダリング終了
    private endRendering()
    {
        this.isRenderingDesign = false;
    }

    // ズーム
    private zoomScale : number = 100;
    private isAutoZoom : boolean = true;

    // オブジェクトリネーム
    private renameId : string = "";

    // ショートカットキー、およびメニューのID
    static readonly MENU_COMMAND_COPY_SELECTED_LAYER = "design_editor_copy_selected_layer";
    static readonly MENU_COMMAND_CUT_SELECTED_LAYER = "design_editor_cut_selected_layer";
    static readonly MENU_COMMAND_PASTE_LAYER = "design_editor_paste_layer";
    static readonly MENU_COMMAND_SAVE_DOCUMENT = "design_editor_save_document";
    static readonly MENU_COMMAND_UNDO = "design_editor_undo";
    static readonly MENU_COMMAND_REDO = "design_editor_redo";
    static readonly MENU_COMMAND_GROUP_SELECTED_LAYER = "design_editor_group_selected_layer";
    static readonly MENU_COMMAND_UNGROUP_SELECTED_LAYER = "design_editor_ungroup_selected_layer";
    static readonly MENU_COMMAND_DELETE = "design_editor_delete";
    static readonly MENU_COMMAND_MOVE_LEFT = "design_editor_move_left";
    static readonly MENU_COMMAND_MOVE_TOP = "design_editor_move_top";
    static readonly MENU_COMMAND_MOVE_RIGHT = "design_editor_move_right";
    static readonly MENU_COMMAND_MOVE_BOTTOM = "design_editor_move_bottom";
    static readonly MENU_COMMAND_ZOOM_IN = "design_editor_zoom_in";
    static readonly MENU_COMMAND_ZOOM_OUT = "design_editor_zoom_out";

    // デザインが存在しているか?
    private isExistDesign()
    {
        var result = false;
        try
        {
            var document = this.$store.getters.document;
            var page = document.pageList[document.currentPageIndex];
            var surface = page.getSurface(document.isReverseSurface);
            var design = surface.getDesign(page.currentDesignPosition);
            if(design != null)
            {
                result = true;
            }
        }
        catch(e)
        {
        }
        DebugHelper.trace("Exist :" + result);
        return result;
    }

    private mounted()
    {
        // デザインが存在してれば表示して良い
        if(this.isExistDesign())
        {
            this.isLoadedDocument = true;

            // すべてのレイヤーからロックを外す
            var currentDesign = this.currentDesign;
            if(currentDesign != null)
            {
                var allLayers = currentDesign.getAllLayers(true);
                for(var i = 0; i < allLayers.length; ++i)
                {
                    allLayers[i].isLocked = false;
                }

                // アンドゥリドゥ変更イベント登録
                this.registerUndoRedoChangeCallback();
            }
        }

        // ショートカット登録
        this.registerShortcut();
        document.addEventListener("keydown", this.onKeyDown);

        if(!CookieHelper.hasItem("isSubControllerVisible")){
            this.isSubControllerVisible = true;
        }else{
            this.isSubControllerVisible = CookieHelper.getItem("isSubControllerVisible")
        }

        // メッセージセンター登録
        var messageCenter = this.$store.getters.messageCenter;
        messageCenter.subscribe(this, "exec_command", this.processExecCommand);

        // TODO 多分もういらないけど残しておく
        // Webfontロード
        FontHelper.loadWebFonts(() =>
        {
            // ロード完了
            this.isFontLoaded = true;
        }, () =>
        {
            // ロード失敗
            this.isFontLoaded = true;
        });

        if(CookieHelper.getItem("license") != true){
            this.isLicense = true;
        }
        else if(CookieHelper.getItem("designEditorTutorial") != true){
            this.isTutorial = true;
        }

        var param = {};
        param["view"] = "DesignEditor";
        NativeHelper.sendNativeEvent("view_mounted", param);
    }

    private registerUndoRedoChangeCallback()
    {
        if(this.currentDesign == null) { return; }
        this.currentDesign.undoRedoManager.registerUndoChangeCallback(this.onChangeUndo);
        this.currentDesign.undoRedoManager.registerRedoChangeCallback(this.onChangeRedo);
    }

    private onChangeUndo()
    {
        var param = {};
        param["enabled"] = this.currentDesign.undoRedoManager.canUndo ? "true" : "false";
        NativeHelper.sendNativeEvent("changed_undo_enable", param);
    }

    private onChangeRedo()
    {
        var param = {};
        param["enabled"] = this.currentDesign.undoRedoManager.canRedo ? "true" : "false";
        NativeHelper.sendNativeEvent("changed_redo_enable", param);
    }

    private destroyed()
    {
        // ショートカット解除
        this.unregisterShortcut();
        document.removeEventListener("keydown", this.onKeyDown);

        // メッセージセンター削除
        var messageCenter = this.$store.getters.messageCenter;
        messageCenter.unsubscribe(this, "exec_command");

        // アンドゥリドゥ変更イベント削除
        this.currentDesign.undoRedoManager.clearUndoChangeCallbacks();
        this.currentDesign.undoRedoManager.clearUndoChangeCallbacks();
    }

    // ヘッダーで遷移するときに呼び出す処理
    private onDisappearHeader(completion : () => void)
    {
        // 画像を更新
        this.updateCanvasImage(completion);
    }

    // コマンド処理
    private processExecCommand(parameterParent : any)
    {
        try
        {
            var command : string = parameterParent.command;
            var parameter : any = parameterParent.parameter;

            if(command == "import_document")
            {
                // ドキュメント読み込み
                try
                {
                    var json = parameter.document;
                    var jsonData = JSON.parse(json);
                    var importDocument = Document.createFromJsonData(jsonData);
                    if(importDocument.useInsertion)
                    {
                        // 差し込みは読み込まない
                        NativeHelper.sendNativeEvent("import_document_error", { about : "useInsertion" });
                        return;
                    }

                    // パラメータ反映
                    if(parameter.page != null) { importDocument.currentPageIndex = parameter.page; }
                    if(parameter.isReverse != null) { importDocument.setSurface(parameter.isReverse == "true"); }
                    if(parameter.position != null)
                    {
                        var page = importDocument.pageList[importDocument.currentPageIndex];
                        page.currentDesignPosition = parameter.position;
                    }
                    // デザインの存在確認
                    var currentPage = importDocument.pageList[importDocument.currentPageIndex];
                    var currentSurface = currentPage.getSurface(importDocument.isReverseSurface);
                    var currentDesign = currentSurface.getDesign(currentPage.currentDesignPosition);
                    if(currentDesign == null || (parameter.createNew != null && parameter.createNew == "true"))
                    {
                        // デザインがない場合 or 新規のとき作る
                        currentSurface.createNewDesign(currentPage.currentDesignPosition);
                    }

                    var finish = () =>
                    {
                        // カレントデザインのすべてのレイヤーのロック状態を外す
                        currentDesign = currentSurface.getDesign(currentPage.currentDesignPosition);
                        if(currentDesign != null)
                        {
                            var allLayers = currentDesign.getAllLayers(true);
                            for(var i = 0; i < allLayers.length; ++i)
                            {
                                allLayers[i].isLocked = false;
                            }
                        }

                        this.$store.dispatch("setDocument", importDocument);
                        // 読み込み完了フラグON
                        setTimeout(() =>
                        {
                            this.isLoadedDocument = true;
                            // アンドゥリドゥ変更イベント登録
                            this.registerUndoRedoChangeCallback();
                        }, 100);
                    };

                    if(parameter.templateId != null && Number(parameter.templateId) > 0)
                    {
                        // テンプレートの読み込みを行う

                        // 縦横比固定、編集の回転角
                        var isKeepRatio = parameter.keepRatio != null && parameter.keepRatio == "true";
                        var designRotate = parameter.designRotate != null ? Number(parameter.designRotate) : 0;

                        var postData = { "id" : "" + parameter.templateId };
                        // urlからテキストを得る
                        RequestHelper.get("get_template_new_content", postData, (response) =>
                        {
                            try
                            {
                                var currentDesign = currentSurface.getDesign(currentPage.currentDesignPosition);
                                if(currentDesign != null)
                                {
                                    // レスポンスをパース
                                    var jsonObject2 = JSON.parse(response);
                                    // コンテンツ取得
                                    var content = jsonObject2.data.templateContents;
                                    // 取得ファイルデータを読み込む
                                    // 復号化
                                    var documentJson = EncryptionHelper.compositeIfNeeded(content)
                                    // jsonのパース
                                    var documentData = JSON.parse(documentJson);
                                    // ドキュメントの作成
                                    var tempdocument = Document.createFromJsonData(documentData);
                                    var command = new ReplaceTemplateCommand(currentDesign, tempdocument, isKeepRatio, designRotate, () => {});
                                    currentDesign.undoRedoManager.do(command);
                                    // アンドゥリドゥマネージャはクリアする
                                    currentDesign.undoRedoManager.init();
                                    // setDesignし直さないと回転が反映しない
                                    currentSurface.setDesign(page.currentDesignPosition, currentDesign);

                                    finish();
                                }
                            }
                            catch(e)
                            {
                                DebugHelper.trace("error" + e);

                                finish();
                            }
                        },
                        () =>
                        {
                            DebugHelper.trace("request error");

                            finish();
                        });
                    }
                    else
                    {
                        // テンプレートの読み込みを行わない
                        finish();
                    }
                }
                catch(eDoc)
                {
                    // ドキュメント読み込み独自でエラーチェックする
                    NativeHelper.sendNativeEvent("import_document_error", { about : "invalid" });
                }
            }
            else if(command == "new_document")
            {
                // 新規ドキュメント
                var productCode = "" + parameter.productCode;
                var rotate = Number(parameter.rotate);
                var templateId = parameter.templateId == null ? 0 : Number(parameter.templateId);
                var keepRatio = parameter.keepRatio === true || parameter.keepRatio === "true";
                var designRotate = parameter.designRotate == null ? 0 : Number(parameter.designRotate);

                // 作成
                InitializeHelper.createInitializeDocument(productCode, rotate, templateId, keepRatio, designRotate, (doc, product, paper, categoryId, hierarchy) =>
                {
                    // 初期設定
                    this.$store.getters.data.selectedProduct = product;
                    this.$store.getters.data.selectedPaper = paper;
                    this.$store.getters.data.paperDirection = Math.round(rotate / 90);
                    this.$store.getters.data.selectTemplateCategory(categoryId, hierarchy);
                    this.$store.dispatch("setDocument" , doc);

                    // 読み込み完了フラグON
                    setTimeout(() =>
                    {
                        this.isLoadedDocument = true;
                        // アンドゥリドゥ変更イベント登録
                        this.registerUndoRedoChangeCallback();
                    }, 100);
                },
                () =>
                {
                    // エラー
                    NativeHelper.sendNativeEvent("new_document_error", { about : "invalid" });
                });
            }
            else if(command == "setup_document_completed")
            {
                // ドキュメントロード完了
                this.isLoadedDocument = true;
            }
            else if(command == "add_layer_test")
            {
                // レイヤー追加テスト処理
                var text = parameter.text ? parameter.text : "Webテスト";
                var textLayer = PlainTextLayer.create(text, 0, 0, this.currentDesign.width / 2, this.currentDesign.height / 2);
                this.newLayer(textLayer, this.currentDesign.layer);
            }
            else if(command == "call_event_test")
            {
                // イベント要求テスト処理
                var message = parameter.message ? parameter.message : "call";
                window.open("native://" + message);
            }
            else if(command == "show_popup_controller")
            {
                // コントローラの表示制御
                var controller = parameter.controller;
                this.showPopupController(controller);
            }
            else if(command == "undo")
            {
                // アンドゥする
                this.currentDesign.undoRedoManager.undo();
            }
            else if(command == "redo")
            {
                // リドゥする
                this.currentDesign.undoRedoManager.redo();
            }
            else if(command == "change_layer_property")
            {
                // レイヤーの特定パラメータの変更
                var layer = this.currentDesign.currentLayer;
                if(layer == null) { return; }
                for(var propertyName in parameter)
                {
                    if(propertyName == "fontId" ||
                        propertyName == "fontSize" ||
                        propertyName == "textColor" ||
                        propertyName == "letterSpacing" ||
                        propertyName == "bold" ||
                        propertyName == "italic" ||
                        propertyName == "underline" ||
                        propertyName == "letterWidth" ||
                        propertyName == "isHorizontalInVertical" ||
                        propertyName == "isEmQuad" ||
                        propertyName == "isShadow" ||
                        propertyName == "shadowColor" ||
                        propertyName == "shadowDistance" ||
                        propertyName == "shadowRotate" ||
                        propertyName == "shadowBlur" ||
                        propertyName == "shadowIntensity" ||
                        propertyName == "isOutline" ||
                        propertyName == "outlineColor" ||
                        propertyName == "outlineThickness" ||
                        propertyName == "outlineIntensity")
                    {
                        // テキストの文法情報変更
                        var value = this.getTypedValue(layer, propertyName, parameter[propertyName], true);
                        if(value != null)
                        {
                            if(layer instanceof ExTextLayer)
                            {
                                if(propertyName == "shadowColor")
                                {
                                    // 強制的に isShadow を true にする
                                    this.changePlainTextLayerWholeTextInfo(layer, "isShadow", true, false, false);
                                }
                                else if(propertyName == "outlineColor")
                                {
                                    // 強制的に isOutline を true にする
                                    this.changePlainTextLayerWholeTextInfo(layer, "isOutline", true, false, false);
                                }
                                this.changePlainTextLayerWholeTextInfo(layer, propertyName, value, false, false);
                            }
                            else if(layer instanceof DateTextLayer)
                            {
                                var newTextInfo: any = layer.textInfo.clone();
                                newTextInfo[propertyName] = value;
                                if(propertyName == "shadowColor")
                                {
                                    // 強制的に isShadow を true にする
                                    newTextInfo.isShadow = true;
                                }
                                else if(propertyName == "outlineColor")
                                {
                                    // 強制的に isOutline を true にする
                                    newTextInfo.isOutline = true;
                                }
                                this.changeLayerProperty(layer, "textInfo", newTextInfo, false, false);
                            }
                        }
                    }
                    else if(layer instanceof ExTextLayer && propertyName == "text")
                    {
                        // テキストの差し替え
                        var value = this.getTypedValue(layer, propertyName, parameter[propertyName], true);
                        if(value != null)
                        {
                            this.changeText(layer, value, false);
                        }
                    }
                    else if((layer instanceof PatternBaseLayer || layer instanceof PolygonLayer) &&
                        (propertyName == "gradationStartColor" || propertyName == "gradationEndColor"))
                    {
                        // 図形のグラデーション開始色変更、終了色変更
                        if(layer.getGradationPointCount() > 1)
                        {
                            var index = propertyName == "gradationStartColor" ? 0 : layer.getGradationPointCount() - 1;
                            if(propertyName == "gradationEndColor" && layer.fillType == 1)
                            {
                                // 塗りつぶし -> グラデーションに変更するため、塗りつぶし色をグラデーションの開始色として設定する
                                this.changeGradationColorOfPattern(layer, 0, layer.fillColor.clone(), false);
                            }
                            // 強制的に fillType を 2 にする
                            this.changeLayerProperty(layer, "fillType", 2, false, false);
                            this.changeGradationColorOfPattern(layer, index, ColorConstruct.createFromHex(parameter[propertyName]), false);
                        }
                    }
                    else
                    {
                        // レイヤーのプロパティ変更
                        var value = this.getTypedValue(layer, propertyName, parameter[propertyName]);
                        if(value != null)
                        {
                            if((layer instanceof PatternBaseLayer || layer instanceof PolygonLayer) && propertyName == "fillColor")
                            {
                                // 強制的に fillType を 1 にする
                                this.changeLayerProperty(layer, "fillType", 1, false, false);
                            }
                            this.changeLayerProperty(layer, propertyName, value, false, false);
                        }
                    }
                }
                // マルチコマンドフィックス
                this.fixMultiCommand();
            }
            else if(command == "import_image")
            {
                // イメージの読み込み
                // base64で与える
                var image = parameter.image;
                // サイズ取得
                ImageHelper.getImageSize(image, size =>
                {
                    var imageWidth = size.width;
                    var imageHeight = size.height;
                    if(imageWidth == 0 || imageHeight == 0) { return; }
                    // 白色透明化画像取得
                    ImageHelper.createWhiteTransparentImage(image, whiteTransparentImage =>
                    {
                        // 画像のサイズはキャンバスの半分にaspect fitで
                        var halfCanvasWidth = this.currentDesign.width / 2;
                        var halfCanvasHeight = this.currentDesign.height / 2;
                        var ratio = Math.min(halfCanvasWidth / imageWidth, halfCanvasHeight / imageHeight);
                        var resizedWidth = imageWidth * ratio;
                        var resizedHeight = imageHeight * ratio;
                        var x = (this.currentDesign.width - resizedWidth) / 2;
                        var y = (this.currentDesign.height - resizedHeight) / 2;
                        // 新規イメージレイヤーを作成
                        var newImageLayer = ImageHelper.isSvg(image) ? VectorImageLayer.create(image, x, y, resizedWidth, resizedHeight) : RasterImageLayer.create(image, x, y, resizedWidth, resizedHeight);
                        // レイヤーに白色透明を追加
                        newImageLayer.setWhiteTransparentImage(whiteTransparentImage);
                        // サイズを設定
                        newImageLayer.imageWidth = imageWidth;
                        newImageLayer.imageHeight = imageHeight;
                        // 名前
                        newImageLayer.name = NameHelper.createLayerName("image", this.currentDesign);
                        // プロパティ適用
                        this.applyPropertyToLayer(newImageLayer, parameter);
                        // デザインの一番上にレイヤー追加
                        this.newLayer(newImageLayer, this.currentDesign.layer);
                    });
                });
            }
            else if(command == "create_pattern")
            {
                // 図形の作成
                var type = parameter.type;
                // サイズはキャンバスの半分を基準とする
                var halfCanvasWidth = this.currentDesign.width / 2;
                var halfCanvasHeight = this.currentDesign.height / 2;
                var patternWidth = Math.min(halfCanvasWidth, halfCanvasHeight);
                var patternHeight = patternWidth;
                var x = (this.currentDesign.width - patternWidth) / 2;
                var y = (this.currentDesign.height - patternHeight) / 2;

                var patternLayer : Layer | null = null;
                if(type == "rect" || type == "rectangle")
                {
                    // 矩形
                    patternLayer = RectangleLayer.create(x, y, patternWidth, patternHeight);
                    patternLayer.name = NameHelper.createLayerName("rectangle", this.currentDesign);
                }
                else if(type == "circle")
                {
                    // 円
                    patternLayer = CircleLayer.create(x, y, patternWidth, patternHeight);
                    patternLayer.name = NameHelper.createLayerName("circle", this.currentDesign);
                }
                else if(type == "polygon")
                {
                    // 多角形
                    var corner = Number(parameter.corner);
                    patternLayer = PolygonLayer.create(corner, true, x, y, patternWidth, patternHeight);
                    patternLayer.name = NameHelper.createLayerName("polygon", this.currentDesign);
                }
                else if(type == "arrow")
                {
                    // 矢印
                    patternLayer = PolygonLayer.create(0, true, x, y, patternWidth, patternHeight);
                    patternLayer.name = NameHelper.createLayerName("polygon", this.currentDesign);
                }
                else if(type == "star")
                {
                    // 星
                    patternLayer = PolygonLayer.create(1, true, x, y, patternWidth, patternHeight);
                    patternLayer.name = NameHelper.createLayerName("polygon", this.currentDesign);
                }

                if(patternLayer != null)
                {
                    // プロパティ適用
                    this.applyPropertyToLayer(patternLayer, parameter);
                    // デザインの一番上にレイヤー追加
                    this.newLayer(patternLayer, this.currentDesign.layer);
                }
            }
            else if(command == "duplicate_layer")
            {
                // レイヤーの複製
                var currentLayer = this.currentDesign.currentLayer;
                if(currentLayer != null)
                {
                    if(this.currentDocument.hasReverseSurface)
                    {
                        // 裏面が存在している場合はコピーコントローラ表示
                        this.showPopupController("copy");
                    }
                    else
                    {
                        // 裏面が存在していない場合はコピーをする
                        this.duplicateLayerToSurface(currentLayer, false);
                    }
                }
            }
            else if(command == "delete_layer")
            {
                // レイヤーの削除
                var currentLayer = this.currentDesign.currentLayer;
                if(currentLayer != null)
                {
                    this.deleteLayer(currentLayer);
                }
            }
            else if(command == "create_line")
            {
                // 直線の作成
                // サイズはキャンバスの半分を基準とする
                var halfCanvasWidth = this.currentDesign.width / 2;
                var halfCanvasHeight = this.currentDesign.height / 2;
                var width = Math.min(halfCanvasWidth, halfCanvasHeight);
                var height = width;
                var x = (this.currentDesign.width - width) / 2;
                var y = (this.currentDesign.height - height) / 2;
                var lineLayer = LineLayer.create(x, y, x + width, y + height);
                lineLayer.name = NameHelper.createLayerName("line", this.currentDesign);
                // プロパティ適用
                this.applyPropertyToLayer(lineLayer, parameter);
                this.newLayer(lineLayer, this.currentDesign.layer);
            }
            else if(command == "create_curve")
            {
                // 曲線の作成
                // サイズはキャンバスの半分を基準とする
                var halfCanvasWidth = this.currentDesign.width / 2;
                var halfCanvasHeight = this.currentDesign.height / 2;
                var width = Math.min(halfCanvasWidth, halfCanvasHeight);
                var height = width;
                var x = (this.currentDesign.width - width) / 2;
                var y = (this.currentDesign.height - height) / 2;
                var curveLayer = CurveLayer.create(x, y, x + width / 2, y + height, x + width, y);
                curveLayer.name = NameHelper.createLayerName("curve", this.currentDesign);
                // プロパティ適用
                this.applyPropertyToLayer(curveLayer, parameter);
                this.newLayer(curveLayer, this.currentDesign.layer);
            }
            else if(command == "create_barcode")
            {
                // バーコードの作成
                // パラメータがあれば使う
                var barcodeType = parameter != null && parameter.type != null && Number(parameter.type) != NaN ? Number(parameter.type) : 0;
                var text = parameter != null && parameter.text != null ? parameter.text : "4912345678904";
                // サイズはキャンバスの半分を基準とする
                var halfCanvasWidth = this.currentDesign.width / 2;
                var halfCanvasHeight = this.currentDesign.height / 2;
                var width = Math.min(halfCanvasWidth, halfCanvasHeight);
                var height = width;
                var x = (this.currentDesign.width - width) / 2;
                var y = (this.currentDesign.height - height) / 2;
                var barcodeLayer = BarcodeLayer.create(barcodeType, text, x, y, width, height);
                barcodeLayer.name = NameHelper.createLayerName("barcode", this.currentDesign);
                // プロパティ適用
                this.applyPropertyToLayer(barcodeLayer, parameter);
                this.newLayer(barcodeLayer, this.currentDesign.layer);
            }
            else if(command == "create_qr")
            {
                // QRコードの作成
                var text = parameter != null && parameter.text != null ? parameter.text : "http://www.a-one.co.jp/";
                // サイズはキャンバスの半分を基準とする
                var halfCanvasWidth = this.currentDesign.width / 2;
                var halfCanvasHeight = this.currentDesign.height / 2;
                var width = Math.min(halfCanvasWidth, halfCanvasHeight);
                var height = width;
                var x = (this.currentDesign.width - width) / 2;
                var y = (this.currentDesign.height - height) / 2;
                var qrcodeLayer = QRcodeLayer.create(text, x, y, width, height);
                qrcodeLayer.name = NameHelper.createLayerName("qrcode", this.currentDesign);
                // プロパティ適用
                this.applyPropertyToLayer(qrcodeLayer, parameter);
                this.newLayer(qrcodeLayer, this.currentDesign.layer);
            }
            else if(command == "rotate_design")
            {
                // デザインの回転
                var delta = parameter != null && parameter.rotate != null ? Number(parameter.rotate) : 90;
                this.rotateDesign(delta);
            }
            else if(command == "create_plain_text")
            {
                // 通常文字レイヤー作成
                var text = parameter != null && parameter.text != null ? parameter.text : "通常文字";
                // サイズはキャンバスの半分を基準とする
                var halfCanvasWidth = this.currentDesign.width / 2;
                var halfCanvasHeight = this.currentDesign.height / 2;
                var width = Math.min(halfCanvasWidth, halfCanvasHeight);
                var height = width;
                var x = (this.currentDesign.width - width) / 2;
                var y = (this.currentDesign.height - height) / 2;
                var plainTextLayer = PlainTextLayer.create(text, x, y, width, height);
                plainTextLayer.name = NameHelper.createLayerName("plaintext", this.currentDesign);
                // プロパティ適用
                this.applyPropertyToLayer(plainTextLayer, parameter);
                this.newTextLayer(plainTextLayer, this.currentDesign.layer);
            }
            else if(command == "update_design_thumbnail")
            {
                // デザインサムネイル更新
                var code = parameter != null && parameter.code != null ? parameter.code : "";
                this.updateCanvasImage(() =>
                {
                    // サムネイル更新メッセージ
                    var param = {};
                    if(code != "") { param["code"] = code; }
                    NativeHelper.sendNativeEvent("updated_design_thumbnail", param);
                });
            }
            else if(command == "reverse_surface")
            {
                // 面を逆にする
                if(this.currentDocument.hasReverseSurface)
                {
                    this.changeSurface(!this.currentDocument.isReverseSurface);
                }
            }
            else if(command == "create_circle_text")
            {
                // 円周文字レイヤー作成
                var text = parameter != null && parameter.text != null ? parameter.text : "円周文字";
                // サイズはキャンバスの半分を基準とする
                var halfCanvasWidth = this.currentDesign.width / 2;
                var halfCanvasHeight = this.currentDesign.height / 2;
                var width = Math.min(halfCanvasWidth, halfCanvasHeight);
                var height = width;
                var x = (this.currentDesign.width - width) / 2;
                var y = (this.currentDesign.height - height) / 2;
                var circleTextLayer = CircleTextLayer.create(text, x, y, width, height);
                circleTextLayer.name = NameHelper.createLayerName("circletext", this.currentDesign);
                // プロパティ適用
                this.applyPropertyToLayer(circleTextLayer, parameter);
                this.newTextLayer(circleTextLayer, this.currentDesign.layer);
            }
            else if(command == "create_date_text")
            {
                // 日付文字レイヤー作成
                // サイズはキャンバスの半分を基準とする
                var halfCanvasWidth = this.currentDesign.width / 2;
                var halfCanvasHeight = this.currentDesign.height / 2;
                var width = Math.min(halfCanvasWidth, halfCanvasHeight);
                var height = width;
                var x = (this.currentDesign.width - width) / 2;
                var y = (this.currentDesign.height - height) / 2;
                var dateTextLayer = DateTextLayer.create(x, y, width, height);
                dateTextLayer.name = NameHelper.createLayerName("datetext", this.currentDesign);
                // プロパティ適用
                this.applyPropertyToLayer(dateTextLayer, parameter);
                this.newTextLayer(dateTextLayer, this.currentDesign.layer);
            }
            else if(command == "trim_image")
            {
                // イメージのトリミング
                var currentLayer = this.currentDesign.currentLayer;
                if(currentLayer == null) { return; }
                var trimx = parameter.x;
                var trimy = parameter.y;
                var trimw = parameter.width;
                var trimh = parameter.height;
                var clipPattern = 0;
                var clipCorner = 0;
                if(parameter.type == "circle")
                {
                    clipPattern = 1;
                }
                else if(parameter.type == "star")
                {
                    clipPattern = 3;
                }
                else if(parameter.type == "arrow")
                {
                    clipPattern = 4;
                }
                else if(parameter.type == "polygon")
                {
                    clipPattern = 5;
                    clipCorner = Number(parameter.corner);
                }

                this.trimLayer(currentLayer, trimx, trimy, trimw, trimh, false);
                this.changeLayerClipShape(currentLayer, clipPattern, clipCorner);
            }
            else if(command == "insert_profile")
            {
                // プロフィール挿入
                var profileData = new ProfileData();
                for(var key in parameter)
                {
                    if(profileData[key] != null)
                    {
                        profileData[key] = parameter[key];
                    }
                }

                this.insertProfile(profileData);
            }
        }
        catch(ex)
        {
            DebugHelper.trace(ex);
        }
    }

    private applyPropertyToLayer(layer : Layer, property)
    {
        if(property == null) { return; }

        for(var key in property)
        {
            var value = this.getTypedValue(layer, key, property[key], false);
            if(value != null)
            {
                layer[key] = value;
            }
        }
    }

    // 与えられた値を適切な型にして戻す
    private getTypedValue(layer : Layer, propertyName : string, value : any, isTextInfo = false) : any
    {
        try
        {
            var property;
            if(isTextInfo)
            {
                if(layer instanceof ExTextLayer)
                {
                    property = layer.baseTextInfo[propertyName];
                }
                else if(layer instanceof DateTextLayer)
                {
                    property = layer.textInfo[propertyName];
                }
            }
            else
            {
                property = layer[propertyName];
            }

            if(typeof(property) == "object")
            {
                if(property instanceof ColorConstruct && typeof(value) == "string")
                {
                    return ColorConstruct.createFromHex(value);
                }
            }
            else if(typeof(property) == "number")
            {
                return Number(value);
            }
            else if(typeof(property) == "boolean")
            {
                return value.toUpperCase() == "TRUE" || value === "1" || value === 1;
            }
            else if(typeof(property) == "string")
            {
                return "" + value;
            }

            return value;
        }
        catch(e)
        {
            return null;
        }
    }

    private registerShortcut()
    {
        // ショートカット登録
        var manager : ShortcutManager = this.$store.getters.shortcutManager;
        manager.addKeyboardShortcut(Edit.MENU_COMMAND_COPY_SELECTED_LAYER, "ctrl", "c", () => this.executeCommand(Edit.MENU_COMMAND_COPY_SELECTED_LAYER), () => this.canExecuteCommand(Edit.MENU_COMMAND_COPY_SELECTED_LAYER));
        manager.addKeyboardShortcut(Edit.MENU_COMMAND_CUT_SELECTED_LAYER, "ctrl", "x", () => this.executeCommand(Edit.MENU_COMMAND_CUT_SELECTED_LAYER), () => this.canExecuteCommand(Edit.MENU_COMMAND_CUT_SELECTED_LAYER));
        manager.addKeyboardShortcut(Edit.MENU_COMMAND_PASTE_LAYER, "ctrl", "v", () => this.executeCommand(Edit.MENU_COMMAND_PASTE_LAYER), () => this.canExecuteCommand(Edit.MENU_COMMAND_PASTE_LAYER));
        manager.addKeyboardShortcut(Edit.MENU_COMMAND_SAVE_DOCUMENT, "ctrl", "s", () => this.executeCommand(Edit.MENU_COMMAND_SAVE_DOCUMENT), () => this.canExecuteCommand(Edit.MENU_COMMAND_SAVE_DOCUMENT));
        manager.addKeyboardShortcut(Edit.MENU_COMMAND_UNDO, "ctrl", "z", () => this.executeCommand(Edit.MENU_COMMAND_UNDO), () => this.canExecuteCommand(Edit.MENU_COMMAND_UNDO));
        manager.addKeyboardShortcut(Edit.MENU_COMMAND_REDO, "ctrl + shift", "z", () => this.executeCommand(Edit.MENU_COMMAND_REDO), () => this.canExecuteCommand(Edit.MENU_COMMAND_REDO));
        manager.addKeyboardShortcut(Edit.MENU_COMMAND_GROUP_SELECTED_LAYER, "ctrl", "g", () => this.executeCommand(Edit.MENU_COMMAND_GROUP_SELECTED_LAYER), () => this.canExecuteCommand(Edit.MENU_COMMAND_GROUP_SELECTED_LAYER));
        manager.addKeyboardShortcut(Edit.MENU_COMMAND_UNGROUP_SELECTED_LAYER, "ctrl + shift", "g", () => this.executeCommand(Edit.MENU_COMMAND_UNGROUP_SELECTED_LAYER), () => this.canExecuteCommand(Edit.MENU_COMMAND_UNGROUP_SELECTED_LAYER));
        manager.addKeyboardShortcut(Edit.MENU_COMMAND_DELETE, "", "backspace", () => this.executeCommand(Edit.MENU_COMMAND_DELETE), () => this.canExecuteCommand(Edit.MENU_COMMAND_DELETE));
        manager.addKeyboardShortcut(Edit.MENU_COMMAND_DELETE, "", "delete", () => this.executeCommand(Edit.MENU_COMMAND_DELETE), () => this.canExecuteCommand(Edit.MENU_COMMAND_DELETE));
        manager.addKeyboardShortcut(Edit.MENU_COMMAND_MOVE_LEFT, "", "ArrowLeft", () => this.executeCommand(Edit.MENU_COMMAND_MOVE_LEFT), () => this.canExecuteCommand(Edit.MENU_COMMAND_MOVE_LEFT));
        manager.addKeyboardShortcut(Edit.MENU_COMMAND_MOVE_TOP, "", "ArrowUp", () => this.executeCommand(Edit.MENU_COMMAND_MOVE_TOP), () => this.canExecuteCommand(Edit.MENU_COMMAND_MOVE_TOP));
        manager.addKeyboardShortcut(Edit.MENU_COMMAND_MOVE_RIGHT, "", "ArrowRight", () => this.executeCommand(Edit.MENU_COMMAND_MOVE_RIGHT), () => this.canExecuteCommand(Edit.MENU_COMMAND_MOVE_RIGHT));
        manager.addKeyboardShortcut(Edit.MENU_COMMAND_MOVE_BOTTOM, "", "ArrowDown", () => this.executeCommand(Edit.MENU_COMMAND_MOVE_BOTTOM), () => this.canExecuteCommand(Edit.MENU_COMMAND_MOVE_BOTTOM));
        manager.addKeyboardShortcut(Edit.MENU_COMMAND_ZOOM_IN, "shift", ";", () => this.executeCommand(Edit.MENU_COMMAND_ZOOM_IN), () => this.canExecuteCommand(Edit.MENU_COMMAND_ZOOM_IN));
        manager.addKeyboardShortcut(Edit.MENU_COMMAND_ZOOM_IN, "shift", "+", () => this.executeCommand(Edit.MENU_COMMAND_ZOOM_IN), () => this.canExecuteCommand(Edit.MENU_COMMAND_ZOOM_IN));
        manager.addKeyboardShortcut(Edit.MENU_COMMAND_ZOOM_IN, "", "+", () => this.executeCommand(Edit.MENU_COMMAND_ZOOM_IN), () => this.canExecuteCommand(Edit.MENU_COMMAND_ZOOM_IN));
        manager.addKeyboardShortcut(Edit.MENU_COMMAND_ZOOM_OUT, "", "-", () => this.executeCommand(Edit.MENU_COMMAND_ZOOM_OUT), () => this.canExecuteCommand(Edit.MENU_COMMAND_ZOOM_OUT));
    }

    // メニューコマンド処理
    private canExecuteCommand(key) : boolean
    {
        var canExecute = false;
        if(key == Edit.MENU_COMMAND_COPY_SELECTED_LAYER)
        {
            canExecute = this.copySelectedLayer(false);
        }
        else if(key == Edit.MENU_COMMAND_CUT_SELECTED_LAYER)
        {
            canExecute = this.cutSelectedLayer(false);
        }
        else if(key == Edit.MENU_COMMAND_PASTE_LAYER)
        {
            canExecute = this.pasteLayer(false);
        }
        else if(key == Edit.MENU_COMMAND_SAVE_DOCUMENT)
        {
            canExecute = true;
        }
        else if(key == Edit.MENU_COMMAND_UNDO)
        {
            canExecute = this.currentDesign.undoRedoManager.canUndo;
        }
        else if(key == Edit.MENU_COMMAND_REDO)
        {
            canExecute = this.currentDesign.undoRedoManager.canRedo;
        }
        else if(key == Edit.MENU_COMMAND_GROUP_SELECTED_LAYER)
        {
            canExecute = this.groupSelectedLayer(false);
        }
        else if(key == Edit.MENU_COMMAND_UNGROUP_SELECTED_LAYER)
        {
            canExecute = this.ungroupSelectedLayer(false);
        }
        else if(key == Edit.MENU_COMMAND_DELETE)
        {
            canExecute = this.deleteSelectedLayer(false);
        }
        else if(key == Edit.MENU_COMMAND_MOVE_LEFT || key == Edit.MENU_COMMAND_MOVE_TOP || key == Edit.MENU_COMMAND_MOVE_RIGHT || key == Edit.MENU_COMMAND_MOVE_BOTTOM)
        {
            if(this.currentDesign.selectLayers.length > 0 && this.currentDesign.currentLayer != null)
            {
                if(this.currentDesign.currentLayer instanceof TextLayer && this.currentDesign.currentLayer.inEdit)
                {
                    // テキスト編集中はキャレットの移動を優先させるので無効
                    canExecute = false;
                }
                else
                {
                    // すべての選択レイヤーがロックされている場合は無効
                    var allLocked = true;
                    for(var i = 0; i < this.currentDesign.selectLayers.length; ++i)
                    {
                        if(!this.currentDesign.selectLayers[i].isLocked) { allLocked = false; }
                    }
                    canExecute = !allLocked;
                }
            }
        }
        else if(key == Edit.MENU_COMMAND_ZOOM_IN || key == Edit.MENU_COMMAND_ZOOM_OUT)
        {
            if(this.isInTextEdit())
            {
                // キーボード操作と文字入力がバッティングするので無効
                canExecute = false;
            }
            else
            {
                canExecute = this.changeZoomScaleByStep(key == Edit.MENU_COMMAND_ZOOM_IN, true, false);
            }
        }
        return canExecute;
    }

    private executeCommand(key) : void
    {
        if(key == Edit.MENU_COMMAND_COPY_SELECTED_LAYER)
        {
            this.copySelectedLayer();
        }
        else if(key == Edit.MENU_COMMAND_CUT_SELECTED_LAYER)
        {
            this.cutSelectedLayer();
        }
        else if(key == Edit.MENU_COMMAND_PASTE_LAYER)
        {
            this.pasteLayer();
        }
        else if(key == Edit.MENU_COMMAND_SAVE_DOCUMENT)
        {
            this.saveDocument();
        }
        else if(key == Edit.MENU_COMMAND_UNDO)
        {
            this.currentDesign.undoRedoManager.undo();
        }
        else if(key == Edit.MENU_COMMAND_REDO)
        {
            this.currentDesign.undoRedoManager.redo();
        }
        else if(key == Edit.MENU_COMMAND_GROUP_SELECTED_LAYER)
        {
            this.groupSelectedLayer();
        }
        else if(key == Edit.MENU_COMMAND_UNGROUP_SELECTED_LAYER)
        {
            this.ungroupSelectedLayer();
        }
        else if(key == Edit.MENU_COMMAND_DELETE)
        {
            this.deleteSelectedLayer();
        }
        else if(key == Edit.MENU_COMMAND_MOVE_LEFT || key == Edit.MENU_COMMAND_MOVE_TOP || key == Edit.MENU_COMMAND_MOVE_RIGHT || key == Edit.MENU_COMMAND_MOVE_BOTTOM)
        {
            // 全ての選択レイヤーのうち、ロックされていないレイヤーを移動する
            var selectedLayers = this.currentDesign.selectLayers;
            for(var i = 0; i < selectedLayers.length; ++i)
            {
                var selectedLayer = selectedLayers[i];
                if(selectedLayer.isLocked) { continue; }
                var newX = selectedLayer.x;
                var newY = selectedLayer.y;
                if(key == Edit.MENU_COMMAND_MOVE_LEFT) { newX -= 1.0; }
                else if(key == Edit.MENU_COMMAND_MOVE_TOP) { newY -= 1.0; }
                else if(key == Edit.MENU_COMMAND_MOVE_RIGHT) { newX += 1.0; }
                else if(key == Edit.MENU_COMMAND_MOVE_BOTTOM) { newY += 1.0; }
                this.transformLayer(selectedLayer, newX, newY, selectedLayer.width, selectedLayer.height, selectedLayer.rotate, false);
            }
            this.fixMultiCommand();
        }
        else if(key == Edit.MENU_COMMAND_ZOOM_IN || key == Edit.MENU_COMMAND_ZOOM_OUT)
        {
            if(this.isInTextEdit())
            {
                // キーボード操作と文字入力がバッティングするので無効
                return;
            }
            else
            {
                this.changeZoomScaleByStep(key == Edit.MENU_COMMAND_ZOOM_IN, true, true);
            }
        }
    }

    private unregisterShortcut()
    {
        // ショートカット解除
        var manager : ShortcutManager = this.$store.getters.shortcutManager;
        manager.removeKeyboardShortcut(Edit.MENU_COMMAND_CUT_SELECTED_LAYER);
        manager.removeKeyboardShortcut(Edit.MENU_COMMAND_PASTE_LAYER);
        manager.removeKeyboardShortcut(Edit.MENU_COMMAND_SAVE_DOCUMENT);
        manager.removeKeyboardShortcut(Edit.MENU_COMMAND_UNDO);
        manager.removeKeyboardShortcut(Edit.MENU_COMMAND_REDO);
        manager.removeKeyboardShortcut(Edit.MENU_COMMAND_DELETE);
        manager.removeKeyboardShortcut(Edit.MENU_COMMAND_MOVE_LEFT);
        manager.removeKeyboardShortcut(Edit.MENU_COMMAND_MOVE_TOP);
        manager.removeKeyboardShortcut(Edit.MENU_COMMAND_MOVE_RIGHT);
        manager.removeKeyboardShortcut(Edit.MENU_COMMAND_MOVE_BOTTOM);
        manager.removeKeyboardShortcut(Edit.MENU_COMMAND_ZOOM_IN);
        manager.removeKeyboardShortcut(Edit.MENU_COMMAND_ZOOM_OUT);
    }

    private onKeyDown(event)
    {
        // ショートカット実行
        var manager : ShortcutManager = this.$store.getters.shortcutManager;
        var applicationState = this.$store.getters.applicationState as ApplicationState;
        if(applicationState.inputMode == 0 && !this.isShorcutDisabled)
        {
            // ショートカットは入力状態がなしのときのみ有効
            manager.doKeyboardShortcutIfNeeded(event);
        }
    }

    private get currentDocument() : Document
    {
        return this.$store.getters.document;
    }

    private get documentRotate()
    {
        return this.currentDocument.rotate;
    }

    private get clipboardManager() : ClipboardManager
    {
        return this.$store.getters.clipboardManager;
    }

    private get currentPage()
    {
        var document = this.currentDocument;
        return document.pageList[document.currentPageIndex];
    }

    private get currentDesign() : Design
    {
      	return this.$store.getters.design;
	}

    private get currentLayer() : Layer | null
    {
      	return this.currentDesign.currentLayer;
    }

    private get isReverseSurface()
    {
        return this.currentDocument.isReverseSurface;
    }

    // テキスト編集中か取得
    private isInTextEdit()
    {
        return this.currentLayer != null && this.currentLayer instanceof TextLayer && this.currentLayer.inEdit;
    }

	// すべてのデザインへの編集は、このクラスから行う
	// action - mutation モデルへの移行も視野に入れている

	// コマンドのコール
	private onDoCommand(command : string, parameter : any)
	{
     	if(command == "newLayer")
		{
			this.newLayer(parameter.newLayer, parameter.parent);
        }
        else if (command === 'newGroupLayerWithSelection')
        {
            this.newGroupLayerWithSelection();
        }
        else if(command == "newTextLayer")
        {
            // テキストレイヤーはサイズ調整が必要なものがあるので別に扱う
            this.newTextLayer(parameter.newLayer, parameter.parent);
        }
		else if(command == "transformLayer")
		{
			this.transformLayer(parameter.layer, parameter.x, parameter.y, parameter.width, parameter.height,
				parameter.rotate, parameter.isFinish);
		}
		else if(command == "changeCurrentLayer")
		{
            if(this.currentLayer != parameter.layer)
            {
                // カレントレイヤーが変更するとき、変形モードリセット
                this.changeEditMode(0);
            }
			this.changeCurrentLayer(parameter.layer);
        }
        else if(command == "selectLayer")
        {
            this.selectLayer(parameter.layer, parameter.isSelect);
        }
        else if(command == "changeSelectLayers")
        {
            this.changeSelectLayers(parameter.layers);
        }
        else if(command === 'appendLayerSelection')
        {
            this.appendLayerSelection(parameter.layer);
        }
        else if(command === 'removeLayerSelection')
        {
            this.removeLayerSelection(parameter.layer);
        }
        else if(command == "moveLayer")
        {
            this.moveLayer(parameter.layer, parameter.x, parameter.y, parameter.isFinish);
        }
        else if(command == "resizeLayer")
        {
            this.resizeLayer(parameter.layer, parameter.width, parameter.height, parameter.isFinish);
        }
        else if(command == "rotateLayer")
        {
            this.rotateLayer(parameter.layer, parameter.rotate, parameter.isFinish);
        }
        else if(command == "changeLayerProperty")
        {
            var isFinish = parameter.isFinish == null ? true : parameter.isFinish;
            var isOnce = parameter.isOnce = null ? false : parameter.isOnce;
            this.changeLayerProperty(parameter.layer, parameter.propertyName, parameter.value, isFinish, isOnce);
        }
        else if(command == "changePlainTextLayerWholeTextInfo")
        {
            var isFinish = parameter.isFinish == null ? true : parameter.isFinish;
            var isOnce = parameter.isOnce = null ? false : parameter.isOnce;
            this.changePlainTextLayerWholeTextInfo(parameter.layer, parameter.propertyName, parameter.value, isFinish, isOnce);
        }
        else if(command == "changePlainTextLayerRangeTextInfo")
        {
            var isFinish = parameter.isFinish == null ? true : parameter.isFinish;
            var isOnce = parameter.isOnce = null ? false : parameter.isOnce;
            this.changePlainTextLayerRangeTextInfo(parameter.layer, parameter.textInfoArray, parameter.startPosition, parameter.endPosition, isFinish, isOnce);
        }
        else if(command == "moveCurveControlPoint")
        {
            var isFinish = parameter.isFinish == null ? true : parameter.isFinish;
            this.moveCurveControlPoint(parameter.layer, parameter.index, parameter.x, parameter.y, isFinish);
        }
        else if(command == "movePolygonControlPoint")
        {
            var isFinish = parameter.isFinish == null ? true : parameter.isFinish;
            this.movePolygonControlPoint(parameter.layer, parameter.index, parameter.x, parameter.y, isFinish);
        }
        else if(command == "applyPolygonControlPoints")
        {
            var isFinish = parameter.isFinish == null ? true : parameter.isFinish;
            var isOnce = parameter.isOnce = null ? true : parameter.isOnce;
            this.applyPolygonControlPoints(parameter.layer, parameter.points, isFinish, isOnce);
        }
        else if(command == "dupilicateLayerToSurface")
        {
            // 面へレイヤー複製
            this.duplicateLayerToSurface(parameter.layer, parameter.isReverse);
        }
        else if(command == "deleteLayer")
        {
            this.deleteLayer(parameter.deleteLayer);
        }
        else if(command == "toLayout")
        {
            // 変形モード解除
            this.changeEditMode(0);

            var flowMode = this.$store.getters.applicationState.flowMode;
            if(flowMode == 1 || flowMode == 2)
            {
                // 差し込みに遷移させる
                this.toInsertion();
            }
            else
            {
                this.toLayout();
            }
        }
        else if(command == "changeSurface")
        {
            this.changeSurface(parameter.isReverse);
        }
        else if(command == "changeText")
        {
            var isFinish = parameter.isFinish == null ? true : parameter.isFinish;
            this.changeText(parameter.layer, parameter.text, parameter.isFinish);
        }
        else if(command == "fixMultiCommand")
        {
            this.fixMultiCommand();
        }
        else if(command == "changeZoomScale")
        {
            // ズーム倍率変更
            var isAutoZoomOff = (parameter.isAutoZoomOff != null) ? parameter.isAutoZoomOff : false;
            this.changeZoomScale(parameter.scale, isAutoZoomOff);
        }
        else if(command == "changeAutoZoom")
        {
            // 自動ズーム切り替え
            this.changeAutoZoom(parameter.isAutoZoom);
        }
        else if(command == "moveLayerPosition")
        {
            this.moveLayerPosition(parameter.layers, parameter.toLayer, parameter.placement);
        }
        else if(command == "showContextMenu")
        {
            // コンテキストメニュー表示
            this.showContextMenu(parameter.event, parameter.type);
        }
        else if(command == "changeCurveEditMode")
        {
            // 曲線編集モード変更
            this.changeCurveEditMode(parameter.mode);
        }
        else if(command == "changeEditMode")
        {
            // 編集モード変更
            this.changeEditMode(parameter.mode);
        }
        else if(command == "addControlPointToCurve")
        {
            // 曲線に制御点追加
            this.addControlPointToCurve(parameter.layer, parameter.index, parameter.x, parameter.y);
        }
        else if(command == "removeControlPointFromCurve")
        {
            // 曲線の制御点削除
            this.removeControlPointFromCurve(parameter.layer, parameter.index);
        }
        else if(command == "rotateDesign")
        {
            // デザインの回転
            this.rotateDesign(parameter.delta);
        }
        else if(command == "addGradationOfPattern")
        {
            // 図形のグラデーション追加
            this.addGradationOfPattern(parameter.layer, parameter.position, parameter.color);
        }
        else if(command == "removeGradationOfPattern")
        {
            // 図形のグラデーション削除
            this.removeGradationOfPattern(parameter.layer, parameter.index);
        }
        else if(command == "selectGradationOfPattern")
        {
            // グラデーションの選択変更
            this.selectGradationOfPattern(parameter.layer, parameter.index);
        }
        else if(command == "changeGradationColorOfPattern")
        {
            // グラデーションの色変更
            var isFinish = parameter.isFinish == null ? true : parameter.isFinish;
            this.changeGradationColorOfPattern(parameter.layer, parameter.index, parameter.color, isFinish);
        }
        else if(command == "changeGradationPositionOfPattern")
        {
            // グラデーションの位置変更
            var isFinish = parameter.isFinish == null ? true : parameter.isFinish;
            this.changeGradationPositionOfPattern(parameter.layer, parameter.index, parameter.position, isFinish);
        }
        else if(command == "initUndoRedo")
        {
            // アンドゥリドゥのクリア
            this.initUndoRedo();
        }
        else if(command == "changeInputMode")
        {
            // インプットモード変更
            this.changeInputMode(parameter.mode);
        }
        else if(command == "selectDesign")
        {
            // 他のデザイン選択
            this.selectDesign(parameter.position);
        }
        else if(command == "goPage")
        {
            // 他のページ切り替え
            this.goPage(parameter.page);
        }
        else if(command == "saveDocument")
        {
            // ドキュメントの保存
            this.saveDocument();
        }
        else if(command == "deleteSelectedLayer")
        {
            // 選択レイヤーの削除
            this.deleteSelectedLayer();
        }
        else if(command == "copySelectedLayer")
        {
            // 選択レイヤーのコピー
            this.copySelectedLayer();
        }
        else if(command == "pasteLayer")
        {
            // レイヤーのペースト
            this.pasteLayer();
        }
        else if(command == "groupSelectedLayer")
        {
            // 選択レイヤーのグループ化
            this.groupSelectedLayer();
        }
        else if(command == "ungroupSelectedLayer")
        {
            // 選択レイヤーのグループ化解除
            this.ungroupSelectedLayer();
        }
        else if(command == "changeTableCellInfo")
        {
            // 表レイヤーのセル情報変更
            var isFinish = parameter.isFinish == null ? true : parameter.isFinish;
            var isOnce = parameter.isOnce = null ? true : parameter.isOnce;
            this.changeTableCellInfo(parameter.layer, parameter.propertyName, parameter.value, isFinish, isOnce);
        }
        else if(command == "changeAllTableCellInfo")
        {
            // 表レイヤーのすべてのセル情報変更
            var isFinish = parameter.isFinish == null ? true : parameter.isFinish;
            this.changeAllTableCellInfo(parameter.layer, parameter.propertyName, parameter.value, isFinish);
        }
        else if(command == "changeTableCellHeight")
        {
            // 表のセルの高さ変更
            var isFinish = parameter.isFinish == null ? true : parameter.isFinish;
            this.changeTableCellHeight(parameter.layer, parameter.value, isFinish)
        }
        else if(command == "changeTableCellWidth")
        {
            // 表のセルの幅変更
            var isFinish = parameter.isFinish == null ? true : parameter.isFinish;
            this.changeTableCellWidth(parameter.layer, parameter.value, isFinish)
        }
        else if(command == "addTableCell")
        {
            // 表のセル追加
            this.addTableCell(parameter.layer, parameter.direction);
        }
        else if(command == "deleteTableCell")
        {
            // 表のセル削除
            this.deleteTableCell(parameter.layer, parameter.isDeleteRow, parameter.isDeleteColumn);
        }
        else if(command == "applyCellColor")
        {
            // セルの色適用
            this.applyCellColor(parameter.layer, parameter.isRow, parameter.isColumn);
        }
        else if(command == "createNumberLayer")
        {
            // 連番レイヤー作成
            this.createNumberLayer(parameter.parent, parameter.layerName, parameter.x, parameter.y, parameter.width, parameter.height);
        }
        else if(command == "moveMultipleLayers")
        {
            // 複数レイヤーの移動
            var isFinish = parameter.isFinish == null ? true : parameter.isFinish;
            this.moveMultipleLayers(parameter.layers, parameter.deltaX, parameter.deltaY, isFinish);
        }
        else if(command == "changeMultipleLayersProperty")
        {
            // 複数レイヤーのプロパティ変更
            var isFinish = parameter.isFinish == null ? true : parameter.isFinish;
            this.changeMultipleLayersProperty(parameter.layers, parameter.propertyName, parameter.value, isFinish);
        }
        else if(command == "alignLayerHorizontal")
        {
            // レイヤーを水平方向に整列する
            this.alignLayerHorizontal(parameter.layer, parameter.alignment);
        }
        else if(command == "alignLayerVertical")
        {
            // レイヤーを垂直方向に整列する
            this.alignLayerVertical(parameter.layer, parameter.alignment);
        }
        else if(command == "alignMultiLayersHorizontal")
        {
            // 複数レイヤーを水平方向に整列する
            this.alignMultiLayersHorizontal(parameter.layers, parameter.alignment);
        }
        else if(command == "alignMultiLayersVertical")
        {
            // 複数レイヤーを垂直方向に整列する
            this.alignMultiLayersVertical(parameter.layers, parameter.alignment);
        }
        else if(command == "trimLayer")
		{
            // レイヤーのトリミング
			this.trimLayer(parameter.layer, parameter.x, parameter.y, parameter.width, parameter.height,
				parameter.isFinish);
        }
        else if(command == "changeLayerClipShape")
        {
            // レイヤーのクリップ形状変更
            this.changeLayerClipShape(parameter.layer, parameter.pattern, parameter.corner);
        }
        else if(command == "exportDesign")
        {
            // デザインの書き出し
            this.exportDesign(parameter.quality, parameter.isClipLayer, parameter.fileType);
        }
        else if(command == "replaceTemplate")
        {
            // テンプレートの差し替え
            this.replaceTemplate();
        }
        else if(command == "replaceImage")
        {
            // 画像の差し替え
            this.replaceImage(parameter.layer, parameter.image, parameter.imageWhiteTransparent, parameter.width, parameter.height, parameter.isSvg);
        }
        else if(command == "insertProfile")
        {
            // プロフィール挿入
            this.insertProfile(parameter.data);
        }
        else if(command == "fixText")
        {
            // テキストを確定する
            this.fixText();
        }
        else if(command == "enableShortcut")
        {
            // ショートカットを有効・無効化する
            this.enableShortcut(parameter.isEnable);
        }
        else if(command == "hidePopupController")
        {
            // Mobile: ポップアップコントローラを表示にする
            this.showPopupController("none");
        }
        else if(command == "moveSelectedLayerDelta")
        {
            // Mobile: 選択レイヤーを差分を指定して移動する
            var isFinish = parameter.isFinish == null ? true : parameter.isFinish;
            var isOnce = parameter.isOnce = null ? false : parameter.isOnce;
            this.moveSelectedLayerDelta(parameter.dx, parameter.dy, parameter.dRotate, parameter.dWidth, parameter.dHeight, isFinish, isOnce)
        }
        else if(command == "orderLayer")
        {
            // Mobile: 選択レイヤーの階層を移動する
            this.orderLayer(parameter.direction);
        }
        else if(command == "sendNativeEvent")
        {
            // Mobile: ネイティブイベントを呼び、ネイティブ側に通知する
            NativeHelper.sendNativeEvent(parameter.message, parameter.parameter);
        }
        else if(command == "scaleLayer")
        {
            var isFinish = parameter.isFinish == null ? true : parameter.isFinish;
            this.scaleLayer(parameter.layer, parameter.width, parameter.height, isFinish);
        }
    }

	// 新規レイヤー
	private newLayer(newLayer : Layer, parent : GroupLayer)
	{
        var command : NewLayerCommand = new NewLayerCommand(newLayer, parent, this.currentDesign, () => {});
        this.currentDesign.undoRedoManager.do(command);

        // カレントレイヤー変更イベントを流す
        this.sendCurrentLayerChanged();
    }

    // 選択したレイヤーを含んだ新しいグループを作る
    private newGroupLayerWithSelection()
    {
        const group = GroupLayer.create();
        group.name = NameHelper.createLayerName('group', this.currentDesign);
        // グループを含んでいると無限ループになるのでルートに作る
        this.currentDesign.undoRedoManager.doAsMultiCommand(
            new AddLayerCommand(group, this.currentDesign.layer)
        );
        // 選択したレイヤーをグループに移動する
        this.moveLayerPosition(this.currentDesign.selectLayers, group, 'inside');

        group.isExpanded = true;
        this.currentDesign.currentLayer = group;
    }

    // 新規テキストレイヤー
    private newTextLayer(newLayer : Layer, parent : GroupLayer)
    {
        // 文字列が入るボックスの縦横比
        var canvasWindow = this.$refs.canvasWindow as CanvasWindow;
        var text = "";
        if(newLayer instanceof TextLayer)
        {
            text = newLayer.text != "" ? newLayer.text : TextLayer.PLACEHOLDER;
        }
        else if(newLayer instanceof DateTextLayer)
        {
            text = newLayer.getText();
        }
        var size = canvasWindow.calcTextSize(text, 64, false, false, false);
        var scale = size.height / size.width;

        // テキストレイヤーの高さ調整
        if(newLayer instanceof D3TextLayer)
        {
            // 3Dテキストレイヤー
            newLayer.height = newLayer.width * scale;
            newLayer.y = (this.currentDesign.height - newLayer.height) / 2;
        }
        else if(newLayer instanceof PlainTextLayer || newLayer instanceof DateTextLayer)
        {
            // 通常文字レイヤー or 日付文字レイヤー
            newLayer.height = newLayer.width * scale;
            newLayer.y = (this.currentDesign.height - newLayer.height) / 2;
        }

        var command : NewLayerCommand = new NewLayerCommand(newLayer, parent, this.currentDesign, () => {});
        this.currentDesign.undoRedoManager.do(command);

        // 新規テキストレイヤー作成時はすぐにテキスト編集開始
        var canvasWindow = this.$refs.canvasWindow as CanvasWindow;
        canvasWindow.forceStartEditText();

        // カレントレイヤー変更イベントを流す
        this.sendCurrentLayerChanged();
    }

	// レイヤー変形
	private transformLayer(layer : Layer, x : number, y : number, width : number, height : number, rotate : number, isFinish : boolean)
	{
        // ロックされてると無効
        if(layer.isLocked) { return; }

		var command : TransformLayerCommand = new TransformLayerCommand(layer, x, y, width, height, rotate, this.currentDesign, () => {});
		this.currentDesign.undoRedoManager.doAsMultiCommand(command, isFinish);
    }

    // レイヤー移動
    private moveLayer(layer : Layer, x : number, y : number, isFinish : boolean)
    {
        // ロックされてると無効
        if(layer.isLocked) { return; }

        var command : TransformLayerCommand = new TransformLayerCommand(layer, x, y, layer.width, layer.height, layer.rotate, this.currentDesign, () => {});
		this.currentDesign.undoRedoManager.doAsMultiCommand(command, isFinish);
    }

    // レイヤーリサイズ
    private resizeLayer(layer : Layer, width : number, height : number, isFinish : boolean)
    {
        // ロックされてると無効
        if(layer.isLocked) { return; }

        var command : TransformLayerCommand = new TransformLayerCommand(layer, layer.x, layer.y, width, height, layer.rotate, this.currentDesign, () => {});
		this.currentDesign.undoRedoManager.doAsMultiCommand(command, isFinish);
    }

    // レイヤー回転
    private rotateLayer(layer : Layer, rotate : number, isFinish : boolean)
    {
        // ロックされてると無効
        if(layer.isLocked) { return; }

        // 中心位置を保持
        var centerX = layer.centerX;
        var centerY = layer.centerY;

        // 前の回転角度と座標を保持
        var oldX = layer.x;
        var oldY = layer.y;
        var oldRotate = layer.rotate;

        // レイヤーを回転する
        layer.rotate = rotate;

        // 中心位置が回転前と同じになるような新しい移動先
        var dstX = layer.x - layer.centerX + centerX;
        var dstY = layer.y - layer.centerY + centerY;

        // レイヤー回転を元に戻す
        layer.rotate = oldRotate;
        layer.x = oldX;
        layer.y = oldY;

        var command : TransformLayerCommand = new TransformLayerCommand(layer, dstX, dstY, layer.width, layer.height, rotate, this.currentDesign, () => {});
		this.currentDesign.undoRedoManager.doAsMultiCommand(command, isFinish);
    }

    // 面へレイヤー複製
    private duplicateLayerToSurface(layer : Layer, isReverse : boolean)
    {
        // コマンド
        var command = new DuplicateLayerToSurfaceCommand(layer, this.currentPage, isReverse, this.currentDocument.isReverseSurface, this.currentPage.currentDesignPosition, this.currentDesign, () => {});

        if(isReverse != this.currentDocument.isReverseSurface)
        {
            // 逆面へのコピー
            // 逆面が存在しているか？
            var isExistSurface = this.currentPage.getSurface(isReverse).getDesign(this.currentPage.currentDesignPosition) != null;
            if(!isExistSurface)
            {
                // 面が存在していないので新規作成
                var newDesignCommand = new NewDesignCommand(this.currentPage.currentDesignPosition, this.currentPage, isReverse, this.currentDocument, () => {});
                this.currentDocument.undoRedoManager.do(newDesignCommand);
            }
            // 逆面のアンドゥ・リドゥに対してコマンドを記録する
            var reverseDesign = this.currentPage.getSurface(isReverse).getDesign(this.currentPage.currentDesignPosition);
            if(reverseDesign != null)
            {
                reverseDesign.undoRedoManager.do(command);
            }
        }
        else
        {
            // カレントデザインにコマンドを記録する
            this.currentDesign.undoRedoManager.do(command);
        }
    }

    // 複数のレイビューを複製する
    private duplicateLayers()
    {
        const layers = this.currentDesign.selectLayers;
        layers.forEach((layer) => {
            this.duplicateLayerToSurface(layer, this.isReverseSurface);
        });
    }

    // レイヤー削除
    private deleteLayer(deleteLayer : Layer)
    {
        // ロックしている場合は削除しない
        if(deleteLayer.isLocked) { return; }

        // ターゲットレイヤーの親を得る。
        var parent = this.currentDesign.getParentLayer(deleteLayer);
        if(parent != null)
        {
            // 親レイヤーから削除する。
            var command = new DeleteLayerCommand(deleteLayer, parent, this.currentDesign, () => {});
            this.currentDesign.undoRedoManager.do(command);
        }
    }

	// カレントレイヤー変更
	private changeCurrentLayer(layer : Layer | null)
	{
		// アンドゥリドゥには残さない
        this.currentDesign.currentLayer = layer;
        this.sendCurrentLayerChanged();
    }

    private sendCurrentLayerChanged()
    {
        var currentLayer = this.currentDesign.currentLayer;
        var parameter = {};
        parameter["layerType"] = currentLayer != null ? currentLayer.layerType : "none";
        NativeHelper.sendNativeEvent("change_current_layer", parameter);
    }

    private appendLayerSelection(layer: Layer)
    {
        this.currentDesign.addSelectLayer(layer);
    }

    private removeLayerSelection(layer: Layer)
    {
        this.currentDesign.removeSelectLayer(layer);
    }

    // 選択レイヤー変更
    private selectLayer(layer : Layer, isSelect : boolean)
    {
        // アンドゥリドゥには残さない
        if(isSelect)
        {
            for(var selectLayer of this.currentDesign.selectLayers)
            {
                if(layer == selectLayer) { return; }
            }
            this.currentDesign.addSelectLayer(layer);
        }
        else
        {
            var isExisted = false;
            for(var selectLayer of this.currentDesign.selectLayers)
            {
                if(layer == selectLayer)
                {
                    isExisted = true;
                    break;
                }
            }
            if(isExisted)
            {
                this.currentDesign.removeSelectLayer(layer);
            }
        }
    }

    // 選択レイヤー一斉変更
    private changeSelectLayers(layers : Array<Layer>)
    {
        // アンドゥリドゥには残さない
        this.currentDesign.clearSelectLayers();
        for(var layer of layers)
        {
            this.currentDesign.addSelectLayer(layer);
        }
    }

    // レイヤープロパティ変更
    private changeLayerProperty(layer : Layer, propertyName : string, value : any, isFinish : boolean, isOnce : boolean)
    {
        var command = new ChangeLayerPropertyCommand(layer, propertyName, value, () => {});

        // 縦横比固定処理はモバイルでは行わない
        // if(propertyName == "keepRatio" && value == 0 &&
        //     (layer.layerType == "rasterImage" || layer.layerType == "vectorImage" || layer.layerType == "rectangle" || layer.layerType == "circle" || layer.layerType == "polygon"))
        // {
        //     // シングルコマンドの場合もマルチコマンドでリサイズを入れる必要がある。
        //     if(isOnce)
        //     {
        //         isOnce = false;
        //         isFinish = true;
        //     }

        //     // レイヤーに対して新しい幅・高さを得る
        //     var newWidth = layer.width;
        //     var newHeight = layer.height;
        //     if(layer instanceof ImageLayer)
        //     {
        //         // まず高さを変える
        //         newHeight = layer.width * layer.imageHeight / layer.imageWidth;
        //         if(newHeight > Math.min(layer.width, layer.height))
        //         {
        //             // レイヤーの短辺を超える場合は幅の方を変える
        //             newHeight = layer.height;
        //             newWidth = layer.height * layer.imageWidth / layer.imageHeight;
        //         }
        //     }
        //     else if(layer instanceof PolygonLayer)
        //     {
        //         // 短辺合わせ
        //         var shorter = Math.min(layer.width, layer.height);
        //         var points = PathHelper.createPolygonControlPoints(layer.cornerNumber, 0, 0, shorter, shorter, true);
        //         var bounds = PathHelper.getBoundsFromPoints(points);
        //         // まず高さを変える
        //         newHeight = layer.width * bounds.height / bounds.width;
        //         if(newHeight > Math.min(layer.width, layer.height))
        //         {
        //             // レイヤーの短辺を超える場合は幅の方を変える
        //             newHeight = layer.height;
        //             newWidth = layer.height * bounds.width / bounds.height;
        //         }
        //     }
        //     else
        //     {
        //         // 短辺合わせ
        //         newWidth = Math.min(layer.width, layer.height);
        //         newHeight = newWidth;
        //     }

        //     // 変形
        //     this.transformLayer(layer, layer.x, layer.y, newWidth, newHeight, layer.rotate, false);
        // }

        if(isOnce)
        {
            this.currentDesign.undoRedoManager.do(command);
        }
        else
        {
            this.currentDesign.undoRedoManager.doAsMultiCommand(command, isFinish);
        }
    }

    // 通常テキストレイヤーの文法情報全変更
    private changePlainTextLayerWholeTextInfo(layer : ExTextLayer, propertyName : string, value : any, isFinish : boolean, isOnce : boolean)
    {
        var command = new ChangePlainTextLayerWholeTextInfoCommand(layer, propertyName, value, () => {});
        if(isOnce)
        {
            this.currentDesign.undoRedoManager.do(command);
        }
        else
        {
            this.currentDesign.undoRedoManager.doAsMultiCommand(command, isFinish);
        }
    }

    // 通常テキストレイヤーの文法情報範囲変更
    private changePlainTextLayerRangeTextInfo(layer : ExTextLayer, textInfoArray : Array<TextInfo>, startPosition : number, endPosition : number, isFinish : boolean, isOnce : boolean)
    {
        var command = new ChangePlainTextLayerRangeTextInfoCommand(layer, textInfoArray, startPosition, endPosition, () => {});
        if(isOnce)
        {
            this.currentDesign.undoRedoManager.do(command);
        }
        else
        {
            this.currentDesign.undoRedoManager.doAsMultiCommand(command, isFinish);
        }
    }

    // 曲線レイヤーの制御点変更
    private moveCurveControlPoint(layer : CurveLayer, index : number, x : number, y : number, isFinish : boolean)
    {
        var command = new MoveCurveControlPointCommand(layer, index, x, y, () => {});
        this.currentDesign.undoRedoManager.doAsMultiCommand(command, isFinish);
    }

    // 多角形レイヤーの制御点変更
    private movePolygonControlPoint(layer : PolygonLayer, index : number, x : number, y : number, isFinish : boolean)
    {
        var command = new MovePolygonControlPointCommand(layer, index, x, y, () => {});
        this.currentDesign.undoRedoManager.doAsMultiCommand(command, isFinish);
    }

    // 多角形レイヤーの制御点適用
    private applyPolygonControlPoints(layer : PolygonLayer, points : Array<Vector2>, isFinish : boolean, isOnce : boolean)
    {
        var command = new ApplyPolygonControlPointsCommand(layer, points, () => {});
        if(isOnce)
        {
            this.currentDesign.undoRedoManager.do(command);
        }
        else
        {
            this.currentDesign.undoRedoManager.doAsMultiCommand(command, isFinish);
        }
    }

    // レイアウトへ遷移
    private toLayout()
    {
        // 画像を更新
        this.updateCanvasImage(() =>
        {
            // 完了したら画面遷移
            this.$router.push("/LayoutEditor");
        });
    }

    // 差し込みに遷移
    private toInsertion()
    {
        // 画像を更新
        this.updateCanvasImage(() =>
        {
            // 完了したら画面遷移
            this.$router.push("/InsertionEditor");
        });
    }

    // デザインの保持するキャンバス画像を更新する
    // デザインの書き出し
    private updateCanvasImage(completion : () => void)
    {
        completion();
        // mobileは毎回更新する

        // レンダリング開始
        // var quality = 3;
        // var isClipLayer = false;
        // this.startRendering(quality, isClipLayer);
        // this.$nextTick(() =>
        // {
        //     var renderer = this.$refs.designrenderer;
        //     if(renderer != null && renderer instanceof DesignRenderer)
        //     {
        //         const done = (img) => {
        //             this.currentDesign.thumbnailImageBase64 = img;

        //             // ハッシュをアップデート
        //             this.currentDesign.updateHash();

        //             completion();
        //         };

        //         const params = renderer.getSvgImage();

        //         // イメージのレンダリングをするためのsvg情報を保持する
        //         this.currentDesign.thumbnailSvg = params.image;
        //         this.currentDesign.thumbnailImageWidth = params.width;
        //         this.currentDesign.thumbnailImageHeight = params.height;
        //         this.currentDesign.thumbnailSvgRotate = this.currentDesign.rotate + this.currentDocument.rotate;

        //         // 完了処理
        //         done("");
        //     }
        //     // レンダリング終了
        //     this.endRendering();
        // });
    }

    // 面変更
    private changeSurface(isReverse : boolean)
    {
        // 面を返す前に、逆の面が存在しているかチェック
        var page = this.currentDocument.pageList[this.currentDocument.currentPageIndex];
        var isExistSurface = page.getSurface(isReverse).getDesign(page.currentDesignPosition) != null;
        // 面が存在していない場合は新規作成
        if(!isExistSurface)
        {
            var command = new NewDesignCommand(page.currentDesignPosition, page, isReverse, this.currentDocument, () => {});
            this.currentDocument.undoRedoManager.do(command);
        }
        this.currentDocument.setSurface(isReverse);
    }

    // テキスト変更
    private changeText(layer : TextLayer, text : string, isFinish : boolean)
    {
        if(isFinish && this.currentDesign.undoRedoManager.multiCommandCount == 0)
        {
            // テキスト変更完了は、multiCommandの数 == 0 のときはテキスト変更がされていないと判定して、行わない。
            return;
        }
        var command = new ChangeTextCommand(layer, text, () => {});
        this.currentDesign.undoRedoManager.doAsMultiCommand(command, isFinish);
    }

    // マルチコマンド終了
    private fixMultiCommand()
    {
        this.currentDesign.undoRedoManager.fixMultiCommand();
    }

    // ズーム倍率変更
    private changeZoomScale(scale, isAutoZoomOff)
    {
        this.zoomScale = scale;

        // オートズーム解除
        if(isAutoZoomOff && this.isAutoZoom) { this.isAutoZoom = false; }
    }

    // ズーム倍率のステップ変更
    private changeZoomScaleByStep(up : boolean, isAutoZoomOff : boolean, doCommand : boolean = true) : boolean
    {
        var result = false;
        if(up)
        {
            // 最大ズームサイズチェック
            if(this.zoomScale < Const.CANVAS_ZOOM_MAX)
            {
                if(doCommand)
                {
                    // ズームサイズを+25
                    var newZoomScale = this.zoomScale + 25;
                    if(newZoomScale > Const.CANVAS_ZOOM_MAX) { newZoomScale = Const.CANVAS_ZOOM_MAX; }
                    this.zoomScale = newZoomScale;
                }
                result = true;
            }
        }
        else
        {
            // 最小ズームサイズチェック
            if(this.zoomScale > Const.CANVAS_ZOOM_MIN)
            {
                if(doCommand)
                {
                    // ズームサイズを-25
                    var newZoomScale = this.zoomScale - 25;
                    if(newZoomScale < Const.CANVAS_ZOOM_MIN) { newZoomScale = Const.CANVAS_ZOOM_MIN; }
                    this.zoomScale = newZoomScale;
                }
                result = true;
            }
        }

        return result;
    }

    // 自動ズーム切り替え
    private changeAutoZoom(isAutoZoom)
    {
        this.isAutoZoom = isAutoZoom;
    }

    // レイヤーの位置を変える
    private moveLayerPosition(layers: Array<Layer>, toLayer: Layer, placement: 'inside' | 'before' | 'after')
    {
        if (placement === 'inside' && !(toLayer instanceof GroupLayer)) { return; }

        layers.forEach((layer: Layer) => {
            // 一旦ツリーから外す
            const parent = this.currentDesign.getParentLayer(layer) as GroupLayer;
            if (parent) {
                this.currentDesign.undoRedoManager.doAsMultiCommand(
                    new DeleteLayerCommand(layer, parent, this.currentDesign, () => {})
                );
            }

            // 改めて追加する
            if (placement === 'inside') {
                this.currentDesign.undoRedoManager.doAsMultiCommand(
                    new NewLayerCommand(layer, <GroupLayer>toLayer, this.currentDesign, () => {})
                );
            }
            else {
                const toParent = this.currentDesign.getParentLayer(toLayer) as GroupLayer;
                if (toParent) {
                    const i = toParent.getLayerIndex(toLayer);
                    const insertIndex = (placement === 'before') ? i + 1 : i;
                    this.currentDesign.undoRedoManager.doAsMultiCommand(
                        new InsertLayerCommand(layer, toParent, insertIndex, this.currentDesign, () => {})
                    );
                }
            }
            this.currentDesign.undoRedoManager.fixMultiCommand();
        });
    }

    // コンテキストメニュー表示
    private showContextMenu(event, type : string)
    {
        DebugHelper.trace(event);
        DebugHelper.trace(type);
        var contextMenu = this.$refs.menu as ContextMenu;
        if(contextMenu != null)
        {
            // menuItems
            var menuItems = new Array();
            if(type == "objectlist")
            {
                // オブジェクトリスト
                var currentLayer = this.currentDesign.currentLayer;
                menuItems.push({ text : "コピー", isEnable : currentLayer != null,  callback : () => { this.onSelectContextMenu("duplicateLayer") } });
                menuItems.push({ text : "削除", isEnable : currentLayer != null && !currentLayer.isLocked,  callback : () => { this.onSelectContextMenu("deleteLayer")} });
                menuItems.push({ text : "ロック/ロック解除", isEnable : currentLayer != null,  callback : () => { this.onSelectContextMenu("lockLayer") } });
                menuItems.push({ text : "最前面へ", isEnable : currentLayer != null,  callback : () => { this.onSelectContextMenu("layerToFront") } });
                menuItems.push({ text : "最背面へ", isEnable : currentLayer != null,  callback : () => { this.onSelectContextMenu("layerToBack") } });
                menuItems.push({ text : "名前変更", isEnable : currentLayer != null,  callback : () => { this.onSelectContextMenu("renameLayer") } });
                if(currentLayer != null && currentLayer instanceof GroupLayer)
                {
                    // グループレイヤーのみ
                    menuItems.push({ text : "開く/閉じる", isEnable : currentLayer != null && currentLayer instanceof GroupLayer,  callback : () => { this.onSelectContextMenu("expandLayer") } });
                }
            }
            else if(type == "layer")
            {
                // オブジェクトリスト
                var currentLayer = this.currentDesign.currentLayer;
                menuItems.push({ text : "コピー", isEnable : currentLayer != null,  callback : () => { this.onSelectContextMenu("duplicateLayer") } });
                menuItems.push({ text : "削除", isEnable : currentLayer != null && !currentLayer.isLocked,  callback : () => { this.onSelectContextMenu("deleteLayer")} });
            }
            contextMenu.open(event, menuItems);
        }
    }

    // コンテキストメニュー処理
    private onSelectContextMenu(menu)
    {
        var currentLayer = this.currentDesign.currentLayer;
        if(menu == "duplicateLayer")
        {
            this.duplicateLayers();
        }
        else if(menu == "deleteLayer")
        {
            this.deleteSelectedLayer();
        }
        else if(menu == "lockLayer")
        {
            // レイヤーロック
            if(currentLayer != null)
            {
                var isLocked = currentLayer.isLocked;
                var lockCommand = new ChangeLayerPropertyCommand(currentLayer, "isLocked", !isLocked, () => {} );
                this.currentDesign.undoRedoManager.do(lockCommand);
            }
        }
        else if(menu == "layerToFront")
        {
            // レイヤーを最前面へ
            if(currentLayer != null)
            {
                var parent = this.currentDesign.getParentLayer(currentLayer);
                var top = this.currentDesign.layer;
                if(parent != null && top != null && top instanceof GroupLayer)
                {
                    // レイヤーをいったん削除する
                    var deleteCommand = new DeleteLayerCommand(currentLayer, parent, this.currentDesign, () => {} );
                    this.currentDesign.undoRedoManager.doAsMultiCommand(deleteCommand, false);
                    // レイヤーを最前面に追加する
                    var newLayerCommand = new NewLayerCommand(currentLayer, top, this.currentDesign, () => {});
                    this.currentDesign.undoRedoManager.doAsMultiCommand(newLayerCommand, true);
                }
            }
        }
        else if(menu == "layerToBack")
        {
            // レイヤーを最背面へ
            if(currentLayer != null)
            {
                var parent = this.currentDesign.getParentLayer(currentLayer);
                var top = this.currentDesign.layer;
                if(parent != null && top != null && top instanceof GroupLayer)
                {
                    // レイヤーをいったん削除する
                    var deleteCommand = new DeleteLayerCommand(currentLayer, parent, this.currentDesign, () => {} );
                    this.currentDesign.undoRedoManager.doAsMultiCommand(deleteCommand, false);
                    // レイヤーを最背面に追加する
                    var insertLayerCommand = new InsertLayerCommand(currentLayer, top, 0, this.currentDesign, () => {});
                    this.currentDesign.undoRedoManager.doAsMultiCommand(insertLayerCommand, true);
                }
            }
        }
        else if(menu == "renameLayer")
        {
            // レイヤーの名前変更
            if(currentLayer != null)
            {
                this.renameId = currentLayer.id;
                this.$nextTick(() =>
                {
                    this.renameId = "";
                });
            }
        }
        else if(menu == "expandLayer")
        {
            // レイヤーの開閉
            if(currentLayer != null && currentLayer instanceof GroupLayer)
            {
                var isExpanded = currentLayer.isExpanded;
                var expandCommand = new ChangeLayerPropertyCommand(currentLayer, "isExpanded", !isExpanded, () => {} );
                this.currentDesign.undoRedoManager.do(expandCommand);
            }
        }
    }

    // 名前の編集が開始された
    private onEditLayerName() {
        // Deleteキーが使えないのでショートカットを一旦OFFにする
        document.removeEventListener("keydown", this.onKeyDown)
    }

    // 名前が変更された
    private onDecideLayerName() {
        // ショートカットを戻す
        document.addEventListener("keydown", this.onKeyDown)
    }

    // 曲線編集モード変更
    private changeCurveEditMode(mode : number)
    {
        this.$store.getters.applicationState.curveEditMode = mode;
    }

    // 編集モード変更
    private changeEditMode(mode : number)
    {
        this.$store.getters.applicationState.editMode = mode;
    }

    // 曲線に制御点追加
    private addControlPointToCurve(layer : CurveLayer, index : number, x : number, y : number)
    {
        var command = new AddControlPointToCurveCommand(layer, index, x, y, () => {});
        this.currentDesign.undoRedoManager.do(command);
    }

    // 曲線の制御点削除
    private removeControlPointFromCurve(layer : CurveLayer, index : number)
    {
        var command = new RemoveControlPointFromCurveCommand(layer, index, () => {});
        this.currentDesign.undoRedoManager.do(command);
    }

    // デザインを指定角度回転
    private rotateDesign(delta : number)
    {
        var command = new RotateDesignCommand(this.currentDesign, delta, () => {});
        this.currentDesign.undoRedoManager.do(command);

        // 強制的にオートリサイズをかける
        var canvasWindow = this.$refs.canvasWindow as CanvasWindow;
        canvasWindow.autoResize();
    }

    // 図形のグラデーションを追加
    private addGradationOfPattern(layer : PatternBaseLayer, position : number, color : ColorConstruct)
    {
        var command = new AddGradationOfPatternCommand(layer, position, color, () => {});
        this.currentDesign.undoRedoManager.do(command);
    }

    // 図形のグラデーションを削除
    private removeGradationOfPattern(layer : PatternBaseLayer, index : number)
    {
        var command = new RemoveGradationOfPatternCommand(layer, index, () => {});
        this.currentDesign.undoRedoManager.do(command);
    }

    // グラデーションの選択変更
    private selectGradationOfPattern(layer : PatternBaseLayer, index : number)
    {
        // アンドゥ、リドゥの対象外
        layer.selectedGradationPoint = index;
    }

    // グラデーションの色変更
    private changeGradationColorOfPattern(layer : PatternBaseLayer | PolygonLayer, index : number, color : ColorConstruct, isFinish : boolean)
    {
        var command = new ChangeGradationColorOfPatternCommand(layer, index, color, () => {});
        this.currentDesign.undoRedoManager.doAsMultiCommand(command, isFinish);
    }

    // グラデーションの位置変更
    private changeGradationPositionOfPattern(layer : PatternBaseLayer | PolygonLayer, index : number, position : number, isFinish : boolean)
    {
        var command = new ChangeGradationPositionOfPatternCommand(layer, index, position, () => {});
        this.currentDesign.undoRedoManager.doAsMultiCommand(command, isFinish);
    }

    // アンドゥリドゥの初期化
    private initUndoRedo()
    {
        this.currentDesign.undoRedoManager.init();
    }

    // インプットモード変更
    private changeInputMode(mode : number)
    {
        this.$store.getters.applicationState.inputMode = mode;
    }

    // 他のデザインを選択
    private selectDesign(position : number)
    {
        // 差し込みの場合はデザイン切り替えなし
        var flowMode = this.$store.getters.applicationState.flowMode;
        if(flowMode == 1 || flowMode == 2) { return; }

        // デザインが存在するか?
        var isExistDesign = this.currentPage.getSurface(this.currentDocument.isReverseSurface).getDesign(position) != null;
        if(!isExistDesign)
        {
            // デザインが存在しないので、新規作成する
            var command = new NewDesignCommand(position, this.currentPage, this.currentDocument.isReverseSurface, this.currentDocument, () => {});
            this.currentDocument.undoRedoManager.do(command);
        }
        // デザインを切り替える
        this.currentPage.currentDesignPosition = position;
    }

    // ページ切り替え
    isAddPageVisible = false
    private goPage(page : number)
    {
        // 差し込みの場合はデザイン切り替えなし
        var flowMode = this.$store.getters.applicationState.flowMode;
        if(flowMode == 1 || flowMode == 2) { return; }

        if(page < 0) {
            return;
        }

        if(this.currentDocument.pageList.length <= page){
            this.isAddPageVisible = true
        }


        var newPage = this.currentDocument.pageList[page];
        // デザインが存在するか?
        var isExistDesign = newPage.getSurface(this.currentDocument.isReverseSurface).getDesign(newPage.currentDesignPosition) != null;
        if(!isExistDesign)
        {
            // デザインが存在しないので、新規作成する
            var command = new NewDesignCommand(newPage.currentDesignPosition, newPage, this.currentDocument.isReverseSurface, this.currentDocument, () => {});
            this.currentDocument.undoRedoManager.do(command);
        }
        // ページを切り替える
        this.currentDocument.currentPageIndex = page;
    }

    // ページを今のページの次に追加
    private addPage()
    {
        // ページ最大数チェック
        if(this.currentDocument.pageCount >= Const.MAX_PAGE_NUMBER)
        {
            DebugHelper.trace("ページ最大数");
            return;
        }

        var command = new NewPageCommand(this.currentDocument.currentPageIndex + 1, this.currentDocument, () => {});
        this.currentDocument.undoRedoManager.do(command);

        //ページを追加したらそのページに飛ぶ
        var document = this.currentDocument;
        this.goPage(document.currentPageIndex + 1);
    }

    // ドキュメントの保存
    private saveDocument()
    {
        // 開いた時のファイル名があればそれを使う
        var fileName = this.currentDocument.openedFileName != "" ? FileHelper.getFilenameWithoutExtension(this.currentDocument.openedFileName) : NameHelper.createNewDocumentFileName(this.currentDocument);
        FileHelper.saveDocument(this.currentDocument, fileName);
    }

    // 選択レイヤーの削除
    private deleteSelectedLayer(doCommand : boolean = true)
    {
        var canExecute = false;

        // 全ての選択レイヤーのうち、ロックされていないレイヤーを削除する
        var selectedLayers = this.currentDesign.selectLayers;
        for(var i = 0; i < selectedLayers.length; ++i)
        {
            var selectedLayer = selectedLayers[i];
            if(selectedLayer.isLocked) { continue; }
            var parentLayer = this.currentDesign.getParentLayer(selectedLayer);
            if(parentLayer == null) { continue; }

            canExecute = true;
            if(doCommand)
            {
                var deleteLayerCommand = new DeleteLayerCommand(selectedLayer, parentLayer, this.currentDesign, () => {});
                this.currentDesign.undoRedoManager.doAsMultiCommand(deleteLayerCommand, false);
            }
        }
        if(doCommand)
        {
            this.fixMultiCommand();
        }

        if(canExecute && doCommand)
        {
            // 全選択を外す
            this.currentDesign.clearSelectLayers();
        }

        return canExecute;
    }

    // 選択レイヤーの切り取り
    private cutSelectedLayer(doCommand : boolean = true)
    {
        // テキスト編集中はできない
        if(this.isInTextEdit()) { return false; }

        var canExecute = false;

        var cutLayers = new Array();
        // 全ての選択レイヤーのうち、ロックされていないレイヤーを削除する
        var selectedLayers = this.currentDesign.selectLayers;
        for(var i = 0; i < selectedLayers.length; ++i)
        {
            var selectedLayer = selectedLayers[i];
            if(selectedLayer.isLocked) { continue; }
            var parentLayer = this.currentDesign.getParentLayer(selectedLayer);
            if(parentLayer == null) { continue; }

            canExecute = true;
            cutLayers.push(selectedLayer);
            if(doCommand)
            {
                var deleteLayerCommand = new DeleteLayerCommand(selectedLayer, parentLayer, this.currentDesign, () => {});
                this.currentDesign.undoRedoManager.doAsMultiCommand(deleteLayerCommand, false);
            }
        }
        this.fixMultiCommand();
        if(cutLayers.length > 0)
        {
            // クリップボードにコピー
            this.clipboardManager.copy(cutLayers);
        }

        return canExecute;
    }

    // 選択レイヤーのコピー
    private copySelectedLayer(doCommand : boolean = true)
    {
        // テキスト編集中はできない
        if(this.isInTextEdit()) { return false; }

        return this.clipboardManager.copy(this.currentDesign.selectLayers, doCommand);
    }

    // レイヤーのペースト
    private pasteLayer(doCommand : boolean = true)
    {
        // テキスト編集中はできない
        if(this.isInTextEdit()) { return false; }

        var canExecute = false;

        var layers = this.clipboardManager.getAsLayerArray();
        if(layers != null && layers.length > 0)
        {
            canExecute = true;
            if(doCommand)
            {
                // ペースト先はカレントがあればその親、なければデザイン直下
                var parent = this.currentLayer != null ? this.currentDesign.getParentLayer(this.currentLayer) : null;
                if(parent == null) { parent = this.currentDesign.layer; }
                // 貼り付け対象となる全レイヤーについて、同じX,Y座標を持つ既存のレイヤーが存在するか調べ、あったら位置をずらす
                var allLayers = this.currentDesign.getAllLayers(false);
                var dx = 0;
                var dy = 0;

                // 永久にチャレンジすると画面外に行ってしまうので32回を限度とします。
                for(var i = 0; i < 32; ++i)
                {
                    if(this.isExistSamePositionLayer(layers, allLayers, dx, dy))
                    {
                        // 2mmずらす
                        dx += 2;
                        dy += 2;
                    }
                    else
                    {
                        break;
                    }
                }

                // すべてのレイヤーを貼り付け
                // 重なり順を一致させるために逆に貼り付ける
                for(var i = layers.length - 1; i >= 0; --i)
                {
                    var pasteLayer = layers[i];
                    // 位置をずらす
                    pasteLayer.x += dx;
                    pasteLayer.y += dy;
                    pasteLayer.insertionId = UuidHelper.getUuid();
                    var command = new NewLayerCommand(pasteLayer, parent, this.currentDesign, () => {});
                    this.currentDesign.undoRedoManager.doAsMultiCommand(command, i == 0);
                }
            }
        }

        return canExecute;
    }

    // 同じ場所にレイヤーが存在するか調べる
    private isExistSamePositionLayer(pastLayers : Array<Layer>, allLayers : Array<Layer>, dx : number, dy : number)
    {
        var isExistSamePositionLayer = false;
        for(var i = 0; i < pastLayers.length; ++i)
        {
            var pasteLayer = pastLayers[i];
            for(var j = 0; j < allLayers.length; ++j)
            {
                var targetLayer = allLayers[j];
                if(MathHelper.equals(pasteLayer.x + dx, targetLayer.x) && MathHelper.equals(pasteLayer.y + dy, targetLayer.y))
                {
                    isExistSamePositionLayer = true;
                    break;
                }
            }
            if(isExistSamePositionLayer) { break; }
        }

        return isExistSamePositionLayer;
    }

    // 選択レイヤーのグループ化
    private groupSelectedLayer(doCommand : boolean = true)
    {
        // テキスト編集中はできない
        if(this.isInTextEdit()) { return false; }

        var canExecute = false;

        var selectedLayers = this.currentDesign.selectLayers;
        if(selectedLayers.length > 0)
        {
            canExecute = true;
            if(doCommand)
            {
                var groupLayer = GroupLayer.create();
                groupLayer.name = NameHelper.createLayerName("group", this.currentDesign);

                // 選択レイヤーをグループに追加
                for(var i = 0; i < selectedLayers.length; ++i)
                {
                    groupLayer.addLayer(selectedLayers[i].clone());
                }

                var parent = this.currentLayer != null ? this.currentDesign.getParentLayer(this.currentLayer) : this.currentDesign.layer;
                if(parent == null) { parent = this.currentDesign.layer; }

                if(this.currentLayer != null)
                {
                    var index = parent.getLayerIndex(this.currentLayer);
                    var insertLayerCommand = new InsertLayerCommand(groupLayer, parent, index + 1, this.currentDesign, () => {});
                    this.currentDesign.undoRedoManager.doAsMultiCommand(insertLayerCommand, false);
                }
                else
                {
                    var newLayerCommand = new NewLayerCommand(groupLayer, parent, this.currentDesign, () => {});
                    this.currentDesign.undoRedoManager.doAsMultiCommand(newLayerCommand, false);
                }

                // 対象レイヤーを削除する
                for(var i = 0; i < selectedLayers.length; ++i)
                {
                    var parentOfSelect = this.currentDesign.getParentLayer(selectedLayers[i]);
                    if(parentOfSelect != null)
                    {
                        var removeCommand = new DeleteLayerCommand(selectedLayers[i], parentOfSelect, this.currentDesign, () => {});
                        this.currentDesign.undoRedoManager.doAsMultiCommand(removeCommand, false);
                    }
                }

                this.fixMultiCommand();
            }
        }

        return canExecute;
    }

    // 選択レイヤーのグループ化解除
    private ungroupSelectedLayer(doCommand : boolean = true)
    {
        // テキスト編集中はできない
        if(this.isInTextEdit()) { return false; }

        var canExecute = false;

        var currentLayer = this.currentDesign.currentLayer;
        if(currentLayer != null && currentLayer instanceof GroupLayer && !currentLayer.isLocked)
        {
            canExecute = true;

            if(doCommand)
            {
                var parent = this.currentDesign.getParentLayer(currentLayer);
                if(parent == null) { parent = this.currentDesign.layer; }
                // レイヤーをグループに追加
                for(var i = 0; i < currentLayer.getLayerCount(); ++i)
                {
                    var layer = currentLayer.getLayer(i).clone();
                    var newLayerCommand = new NewLayerCommand(layer, parent, this.currentDesign, () => {});
                    this.currentDesign.undoRedoManager.doAsMultiCommand(newLayerCommand, false);
                }
                // グループレイヤーを削除
                var deleteLayerCommand = new DeleteLayerCommand(currentLayer, parent, this.currentDesign, () => {});
                this.currentDesign.undoRedoManager.doAsMultiCommand(deleteLayerCommand, true);
            }
        }

        return canExecute;
    }

    // 表レイヤーのセル情報変更
    private changeTableCellInfo(layer : TableLayer, propertyName : string, value : any, isFinish : boolean, isOnce : boolean)
    {
        var command = new ChangeTableCellInfoCommand(layer, layer.currentRow, layer.currentColumn, propertyName, value, () => {});
        if(isOnce)
        {
            this.currentDesign.undoRedoManager.do(command);
        }
        else
        {
            this.currentDesign.undoRedoManager.doAsMultiCommand(command, isFinish);
        }
    }

    // 表レイヤーのすべてのセル情報変更
    private changeAllTableCellInfo(layer : TableLayer, propertyName : string, value : any, isFinish : boolean)
    {
        for(var r = 0; r < layer.row; ++r)
        {
            for(var c = 0; c < layer.column; ++c)
            {
                var command = new ChangeTableCellInfoCommand(layer, r, c, propertyName, value, () => {});
                this.currentDesign.undoRedoManager.doAsMultiCommand(command, false);
            }
        }
        if(isFinish)
        {
            this.fixMultiCommand();
        }
    }

    // 表レイヤーのセル情報変更(セル指定)
    private changeTableCellInfoByCell(layer : TableLayer, row : number, column : number, propertyName : string, value : any, isFinish : boolean, isOnce : boolean)
    {
        var command = new ChangeTableCellInfoCommand(layer, row, column, propertyName, value, () => {});
        if(isOnce)
        {
            this.currentDesign.undoRedoManager.do(command);
        }
        else
        {
            this.currentDesign.undoRedoManager.doAsMultiCommand(command, isFinish);
        }
    }

    // 表レイヤーのセル高さ変更
    private changeTableCellHeight(layer : TableLayer, value : number, isFinish : boolean)
    {
        var row = layer.currentRow;
        // 今の該当セルの高さ(mm)
        var rowHeight = layer.getCellInfo(row, 0).cellHeightNormalized * layer.height / 100;
        // 新しい値との差
        var delta = value - rowHeight;
        // 新しい高さ
        var newHeight = layer.height + delta;
        // 新しい高さに対して、すべてのセルの高さを再計算する
        for(var r = 0; r < layer.row; ++r)
        {
            for(var c = 0; c < layer.column; ++c)
            {
                var newCellHeight = r == row ? value : layer.getCellInfo(r, c).cellHeightNormalized * layer.height / 100;
                var newCellHeightNomalized = newCellHeight / newHeight * 100;
                this.changeTableCellInfoByCell(layer, r, c, "cellHeightNormalized", newCellHeightNomalized, false, false);
            }
        }

        // 高さを更新する
        this.resizeLayer(layer, layer.width, newHeight, isFinish);
    }

    // 表レイヤーのセル幅変更
    private changeTableCellWidth(layer : TableLayer, value : number, isFinish : boolean)
    {
        var column = layer.currentColumn;
        // 今の該当セルの幅(mm)
        var columnWidth = layer.getCellInfo(0, column).cellWidthNormalized * layer.width / 100;
        // 新しい値との差
        var delta = value - columnWidth;
        // 新しい幅
        var newWidth = layer.width + delta;
        // 新しい幅に対して、すべてのセルの幅を再計算する
        for(var r = 0; r < layer.row; ++r)
        {
            for(var c = 0; c < layer.column; ++c)
            {
                var newCellWidth = c == column ? value : layer.getCellInfo(r, c).cellWidthNormalized * layer.width / 100;
                var newCellWidthNomalized = newCellWidth / newWidth * 100;
                this.changeTableCellInfoByCell(layer, r, c, "cellWidthNormalized", newCellWidthNomalized, false, false);
            }
        }

        // 幅を更新する
        this.resizeLayer(layer, newWidth, layer.height, isFinish);
    }

    // 表レイヤーのセル追加
    private addTableCell(layer : TableLayer, direction : number)
    {
        // カレントがない場合は最終セル
        var row = layer.currentRow >= 0 ? layer.currentRow : layer.row - 1
        var column = layer.currentColumn >= 0 ? layer.currentColumn : layer.column - 1;

        var command = new AddTableCellCommand(layer, row, column, direction, () => {});
        this.currentDesign.undoRedoManager.do(command);
    }

    // 表レイヤーのセル削除
    private deleteTableCell(layer : TableLayer, isDeleteRow : boolean, isDeleteColumn : boolean)
    {
        // 行・列はそれぞれ0にできない
        if(isDeleteRow && layer.row <= 1) { return; }
        if(isDeleteColumn && layer.column <= 1) { return; }

        // カレントがない場合は最終セル
        var row = layer.currentRow >= 0 ? layer.currentRow : layer.row - 1
        var column = layer.currentColumn >= 0 ? layer.currentColumn : layer.column - 1;

        var command = new DeleteTableCellCommand(layer, row, column, isDeleteRow, isDeleteColumn, () => {});
        this.currentDesign.undoRedoManager.do(command);
    }

    // 表レイヤーのセル色適用
    private applyCellColor(layer : TableLayer, isRow : boolean, isColumn : boolean)
    {
        // カレントがない場合は最終セル
        var row = layer.currentRow >= 0 ? layer.currentRow : layer.row - 1
        var column = layer.currentColumn >= 0 ? layer.currentColumn : layer.column - 1;

        // 色取得
        var color = layer.getCellInfo(row, column).backgroundColor;

        if(isRow)
        {
            // 同じ行にあるセルについて色変更
            for(var c = 0; c < layer.column; ++c)
            {
                this.changeTableCellInfoByCell(layer, row, c, "backgroundColor", color.clone(), false, false);
            }
        }
        if(isColumn)
        {
            // 同じ列にあるセルについて色変更
            for(var r = 0; r < layer.row; ++r)
            {
                this.changeTableCellInfoByCell(layer, r, column, "backgroundColor", color.clone(), false, false);
            }
        }

        this.fixMultiCommand();
    }

    // 連番レイヤー作成
    private createNumberLayer(parent : GroupLayer, name : string, x : number, y : number, width : number, height : number)
    {
        var newLayer = NumberLayer.create(this.currentDocument, x, y, width, height);
        // 文字列が入るボックスの縦横比
        var canvasWindow = this.$refs.canvasWindow as CanvasWindow;
        // 0のときのサイズで初期化される
        var text = newLayer.getText();
        var size = canvasWindow.calcTextSize(text, 64, false, false, false);
        var scale = size.height / size.width;
        newLayer.height = newLayer.width * scale;
        newLayer.y = (this.currentDesign.height - newLayer.height) / 2;
        newLayer.name = name;

        var command : NewLayerCommand = new NewLayerCommand(newLayer, parent, this.currentDesign, () => {});
		this.currentDesign.undoRedoManager.do(command);
    }

    // 複数レイヤーの移動
    private moveMultipleLayers(layers : Array<Layer>, deltaX : number, deltaY : number, isFinish : boolean)
    {
        for(var i = 0; i < layers.length; ++i)
        {
            var layer = layers[i];
            var newX = layer.x + deltaX;
            var newY = layer.y + deltaY;
            this.transformLayer(layer, newX, newY, layer.width, layer.height, layer.rotate, false);
        }
        if(isFinish)
        {
            this.fixMultiCommand();
        }
    }

    // 複数レイヤーのプロパティ変更
    private changeMultipleLayersProperty(layers : Array<Layer>, propertyName : string, value : any, isFinish : boolean)
    {
        for(var i = 0; i < layers.length; ++i)
        {
            this.changeLayerProperty(layers[i], propertyName, value, false, false);
        }
        if(isFinish)
        {
            this.fixMultiCommand();
        }
    }

    // レイヤーの水平方向整列
    private alignLayerHorizontal(layer : Layer, alignment : string)
    {
        // ロックされてると無効
        if(layer.isLocked) { return; }

        // レイヤーの外接矩形
        var bounds = layer.getBoundingRect();
        // 移動差分
        var deltaX = 0;

        if(alignment == "left")
        {
            // 左
            deltaX = -bounds.x;
        }
        else if(alignment == "center" || alignment == "even")
        {
            // 中央 or 均等
            deltaX = (this.currentDesign.width - bounds.width) / 2 - bounds.x;

        }
        else if(alignment == "right")
        {
            // 右
            deltaX = this.currentDesign.width - bounds.width - bounds.x;
        }

        if(!MathHelper.equals(deltaX, 0))
        {
            // 移動する
            this.moveLayer(layer, layer.x + deltaX, layer.y, true);
        }
    }

    // レイヤーの垂直方向整列
    private alignLayerVertical(layer : Layer, alignment : string)
    {
        // ロックされてると無効
        if(layer.isLocked) { return; }

        // レイヤーの外接矩形
        var bounds = layer.getBoundingRect();
        // 移動差分
        var deltaY = 0;

        if(alignment == "top")
        {
            // 上
            deltaY = -bounds.y;
        }
        else if(alignment == "center" || alignment == "even")
        {
            // 中央 or 均等
            deltaY = (this.currentDesign.height - bounds.height) / 2 - bounds.y;

        }
        else if(alignment == "bottom")
        {
            // 下
            deltaY = this.currentDesign.height - bounds.height - bounds.y;
        }

        if(!MathHelper.equals(deltaY, 0))
        {
            // 移動する
            this.moveLayer(layer, layer.x, layer.y + deltaY, true);
        }
    }

    // 複数レイヤーの水平揃え
    private alignMultiLayersHorizontal(layers : Array<Layer>, alignment : string)
    {
        // 全レイヤーの外接矩形
        var allBounds = this.getMultiLayersBounds(layers);
        // ロックレイヤーを外したレイヤー
        var layersWithoutLocked : Array<Layer> = new Array();
        // レイヤーの外接矩形の合計
        var boundsSum = 0;
        for(var i = 0; i < layers.length; ++i)
        {
            if(layers[i].isLocked) { continue; }
            layersWithoutLocked.push(layers[i]);
            boundsSum += layers[i].getBoundingRect().width;
        }
        if(alignment == "even" && layersWithoutLocked.length > 1 )
        {
            // 均等揃え
            // レイヤーを水平外接矩形が左にある順にソートする。
            var sortedLayers = ArrayHelper.orderby(layersWithoutLocked, (l) => l.getBoundingRect().x);
            // 均等配置する間隔
            var distance = (allBounds.width - boundsSum) / (layersWithoutLocked.length - 1);
            // 配置し直し
            for(var i = 0; i < sortedLayers.length; ++i)
            {
                if(i == 0) { continue; }

                // 新しい外接矩形のx座標
                var newBoundsX = sortedLayers[i - 1].getBoundingRect().right + distance;
                var targetLayer = sortedLayers[i];
                var deltaX = newBoundsX - targetLayer.getBoundingRect().x;
                if(!MathHelper.equals(deltaX, 0))
                {
                    // 移動する
                    this.moveLayer(targetLayer, targetLayer.x + deltaX, targetLayer.y, false);
                }
            }
        }
        else
        {
            if(layersWithoutLocked.length <= 1)
            {
                // 対象のレイヤーが1つの場合は、基準矩形をデザインとする
                allBounds.x = 0;
                allBounds.y = 0;
                allBounds.width = this.currentDesign.width;
                allBounds.height = this.currentDesign.height;
            }
            for(var i = 0; i < layers.length; ++i)
            {
                var layer = layers[i];
                // ロックされていたら対象外
                if(layer.isLocked) { continue; }

                var bounds = layer.getBoundingRect();
                var deltaX = 0;
                if(alignment == "left")
                {
                    // 左
                    deltaX = allBounds.x - bounds.x;
                }
                else if(alignment == "center" || alignment == "even")
                {
                    // 中央 or 均等
                    deltaX = (2 * allBounds.x + allBounds.width - bounds.width) / 2 - bounds.x;
                }
                else if(alignment == "right")
                {
                    // 右
                    deltaX = allBounds.x + allBounds.width - bounds.width - bounds.x;
                }

                if(!MathHelper.equals(deltaX, 0))
                {
                    // 移動する
                    this.moveLayer(layer, layer.x + deltaX, layer.y, false);
                }
            }
        }

        // コマンド確定
        this.fixMultiCommand();
    }

    // 複数レイヤーの垂直揃え
    private alignMultiLayersVertical(layers : Array<Layer>, alignment : string)
    {
        // 全レイヤーの外接矩形
        var allBounds = this.getMultiLayersBounds(layers);
        // ロックレイヤーを外したレイヤー
        var layersWithoutLocked : Array<Layer> = new Array();
        // レイヤーの外接矩形の合計
        var boundsSum = 0;
        for(var i = 0; i < layers.length; ++i)
        {
            if(layers[i].isLocked) { continue; }
            layersWithoutLocked.push(layers[i]);
            boundsSum += layers[i].getBoundingRect().height;
        }
        if(alignment == "even" && layersWithoutLocked.length > 1)
        {
            // 均等揃え
            // レイヤーを水平外接矩形が上にある順にソートする。
            var sortedLayers = ArrayHelper.orderby(layersWithoutLocked, (l) => l.getBoundingRect().y);
            // 均等配置する間隔
            var distance = (allBounds.height - boundsSum) / (layersWithoutLocked.length - 1);
            // 配置し直し
            for(var i = 0; i < sortedLayers.length; ++i)
            {
                if(i == 0) { continue; }

                // 新しい外接矩形のy座標
                var newBoundsY = sortedLayers[i - 1].getBoundingRect().bottom + distance;
                var targetLayer = sortedLayers[i];
                var deltaY = newBoundsY - targetLayer.getBoundingRect().y;
                if(!MathHelper.equals(deltaY, 0))
                {
                    // 移動する
                    this.moveLayer(targetLayer, targetLayer.x, targetLayer.y + deltaY, false);
                }
            }
        }
        else
        {
            if(layersWithoutLocked.length <= 1)
            {
                // 対象のレイヤーが1つの場合は、基準矩形をデザインとする
                allBounds.x = 0;
                allBounds.y = 0;
                allBounds.width = this.currentDesign.width;
                allBounds.height = this.currentDesign.height;
            }
            for(var i = 0; i < layers.length; ++i)
            {
                var layer = layers[i];
                // ロックされていたら対象外
                if(layer.isLocked) { continue; }

                var bounds = layer.getBoundingRect();
                var deltaY = 0;
                if(alignment == "top")
                {
                    // 上
                    deltaY = allBounds.y - bounds.y;
                }
                else if(alignment == "center" || alignment == "even")
                {
                    // 中央 or 均等
                    deltaY = (2 * allBounds.y + allBounds.height - bounds.height) / 2 - bounds.y;
                }
                else if(alignment == "bottom")
                {
                    // 下
                    deltaY = allBounds.y + allBounds.height - bounds.height - bounds.y;
                }

                if(!MathHelper.equals(deltaY, 0))
                {
                    // 移動する
                    this.moveLayer(layer, layer.x, layer.y + deltaY, false);
                }
            }
        }

        // コマンド確定
        this.fixMultiCommand();
    }

    // 複数レイヤーの外接矩形
    // isLockedLayerIqnored : ロックレイヤーを含めない
    private getMultiLayersBounds(layers : Array<Layer>, isLockedLayerIqnored = true)
    {
        var minX = 0;
        var minY = 0;
        var maxX = 0;
        var maxY = 0;
        for(var i = 0; i < layers.length; ++i)
        {
            var layer = layers[i];
            if(isLockedLayerIqnored && layer.isLocked) { continue; }
            var bounds = layer.getBoundingRect();
            minX = i == 0 ? bounds.x : Math.min(bounds.x, minX);
            minY = i == 0 ? bounds.y : Math.min(bounds.y, minY);
            maxX = i == 0 ? bounds.x + bounds.width : Math.max(bounds.x + bounds.width, maxX);
            maxY = i == 0 ? bounds.y + bounds.height : Math.max(bounds.y + bounds.height, maxY);
        }

        return new Rectangle(minX, minY, maxX - minX, maxY - minY);
    }

    // レイヤーのトリミング
    private trimLayer(layer : Layer, x : number, y : number, width : number, height : number, isFinish = false)
    {
        // ロックのとき無効
        if(layer.isLocked) { return; }
        // ImageLayerのみ
        if(!(layer instanceof ImageLayer)) { return; }
        var newTrimRect = new Rectangle(x, y, width, height);
        // プロパティ変更
        if(!layer.isTrim)
        {
            // トリム無効の場合は有効にする
            this.changeLayerProperty(layer, "isTrim", true, false, false);
        }
        this.changeLayerProperty(layer, "trimRectNormalized", newTrimRect, isFinish, false);
    }

    // レイヤーのクリップ形状変更
    private changeLayerClipShape(layer : Layer, pattern : number, corner : number)
    {
        // ロックのとき無効
        if(layer.isLocked) { return; }
        // ImageLayerのみ
        if(!(layer instanceof ImageLayer)) { return; }

        // 形状取得
        var isClip = false;
        var svgPath = "";
        if(pattern == 0 && corner == 0)
        {
            // 矩形の場合はクリップなし
            isClip = false;
            svgPath = "";
        }
        else
        {
            // 形状取得
            isClip = true;
            // サイズ基準は100 x 100, 自動高さ変更は行わない
            var outHeight = { height : 0 };
            svgPath = PathHelper.createPattern(pattern, corner, 0, 0, 100, 100, 0, 0, 0, false, outHeight);
        }

        // レイヤープロパティ変更
        this.changeLayerProperty(layer, "isTrim", true, false, false);
        this.changeLayerProperty(layer, "isClip", isClip, false, false);
        this.changeLayerProperty(layer, "clipShapeSvgPath", svgPath, true, false);
    }

    // デザインの書き出し
    private exportDesign(quality : number, isClipLayer : boolean, fileType : string)
    {
        // レンダリング開始
        this.startRendering(quality, isClipLayer);
        this.$nextTick(() =>
        {
            var renderer = this.$refs.designrenderer;
            if(renderer != null && renderer instanceof DesignRenderer)
            {
                // svgイメージを取得
                var imageParameter = renderer.getSvgImage();
                // pngに変換する
                ImageHelper.svg2png(imageParameter.image, imageParameter.width, imageParameter.height, png =>
                {
                    if(fileType == "jpg")
                    {
                        // jpgに変換する
                        ImageHelper.png2jpg(png, jpg =>
                        {
                            // jpgとして保存
                            FileHelper.saveImage(jpg, "jpg", "output.jpg");
                        });
                    }
                    else
                    {
                        // pngとして保存
                        FileHelper.saveImage(png, "png", "output.png");
                    }
                });
            }
            // レンダリング終了
            this.endRendering();
        });
    }

    // テンプレートの差し替え
    private replaceTemplate()
    {
        // テンプレート選択に遷移する
        this.$router.push("/SelectTemplate");
    }

    // 画像の差し替え
    private replaceImage(layer : Layer, image : string, imageWhiteTransparent : string, width : number, height : number, isSvg : boolean)
    {
        // ロックのとき無効
        if(layer.isLocked) { return; }
        // 画像レイヤーで、また画像が正常な時のみ
        if(!(layer instanceof ImageLayer) || width <= 0 || height <= 0 || image == "" || imageWhiteTransparent == "") { return; }

        // 差し替え用レイヤーを生成する
        var replacedLayer = isSvg ? VectorImageLayer.createImageReplacedLayer(layer, image, imageWhiteTransparent, width, height) : RasterImageLayer.createImageReplacedLayer(layer, image, imageWhiteTransparent, width, height);
        // 元のレイヤーの親
        var parent = this.currentDesign.getParentLayer(layer);
        if(parent != null)
        {
            // 元のレイヤーのインデックス
            var index = parent.getLayerIndex(layer);
            // レイヤー削除
            var deleteLayerCommand = new DeleteLayerCommand(layer, parent, this.currentDesign, () => {});
            this.currentDesign.undoRedoManager.doAsMultiCommand(deleteLayerCommand, false);
            // レイヤー挿入
            var insertLayerCommand = new InsertLayerCommand(replacedLayer, parent, index, this.currentDesign, () => {});
            this.currentDesign.undoRedoManager.doAsMultiCommand(insertLayerCommand, true);
        }
    }

    // プロフィール挿入
    private insertProfile(data : ProfileData)
    {
        var command = new InsertProfileCommand(data, this.currentDesign, () => {});
        this.currentDesign.undoRedoManager.do(command);
    }

    // テキストの編集確定
    private fixText()
    {
        // マルチコマンド確定
        this.fixMultiCommand();

        var canvasWindow = this.$refs.canvasWindow as CanvasWindow;
        if(canvasWindow != null)
        {
            canvasWindow.isTextInEdit = false;
        }
    }

    // ショートカットの有効・無効化
    private enableShortcut(isEnable : boolean)
    {
        this.isShorcutDisabled = !isEnable;
    }

    // モバイル用コントローラ表示
    private showPopupController(controller : string)
    {
        this.popupControllerType = controller;
    }

    // コントローラタッチイベント
    private popupTouchState = "none"
    private onTouchMovePopup()
    {
        this.popupTouchState = "move";
    }
    private onTouchEndPopup()
    {
        this.popupTouchState = "none";
    }

    // 選択レイヤーを差分を指定して移動
    private moveSelectedLayerDelta(dx : number, dy : number, dRotate : number, dWidth : number, dHeight : number, isFinish : boolean, isOnce : boolean)
    {
        var selectedLayers = this.currentDesign.selectLayers;
        for(var i = 0; i < selectedLayers.length; ++i)
        {
            var layer = selectedLayers[i];
            // ロックされていると無効
            if(layer.isLocked) { continue; }

            // 回転後の角度を-180~180に収める
            var rotate = layer.rotate + dRotate;
            while(rotate > 180) { rotate -= 360; }
            while(rotate < -180) { rotate += 360; }

            var srcCenterX = layer.centerX;
            var srcCenterY = layer.centerY;

            var command = new TransformLayerCommand(layer, layer.x + dx, layer.y + dy, layer.width + dWidth, layer.height + dHeight, rotate, this.currentDesign, () => {});
            this.currentDesign.undoRedoManager.doAsMultiCommand(command, false);

            if(dx == 0 && dy == 0 && (dRotate != 0 || dWidth != 0 || dHeight != 0))
            {
                // 回転、拡大縮小してもレイヤーの中心位置を変えないように移動補正する
                var dstCenterX = layer.centerX;
                var dstCenterY = layer.centerY;
                var tempCommand = new TransformLayerCommand(layer, layer.x - dstCenterX + srcCenterX, layer.y - dstCenterY + srcCenterY, layer.width, layer.height, layer.rotate, this.currentDesign, () => {});
                this.currentDesign.undoRedoManager.doAsMultiCommand(tempCommand, false);
            }
        }

        if(isFinish || isOnce)
        {
            this.fixMultiCommand();
        }
    }

    // 選択レイヤーの階層を一つ入れ替え
    private orderLayer(direction : string)
    {
        // 対象はカレントレイヤー
        var currentLayer = this.currentDesign.currentLayer;
        if(currentLayer != null)
        {
            var parent = this.currentDesign.getParentLayer(currentLayer);
            if(parent == null) { return; }
            var allLayers = this.currentDesign.getAllLayers(false);
            // 一つ上の階層のレイヤー
            var upperLayer : Layer | null = null;
            // 一つ下の階層のレイヤー
            var lowerLayer : Layer | null = null;
            var index = 0;
            for(var i = 0; i < allLayers.length; ++i)
            {
                if(allLayers[i] == currentLayer)
                {
                    index = i;
                    break;
                }
            }
            if(0 <= index + 1 && index + 1 < allLayers.length) { upperLayer = allLayers[index + 1]; }
            if(0 <= index - 1 && index - 1 < allLayers.length) { lowerLayer = allLayers[index - 1]; }

            if(direction == "up")
            {
                if(upperLayer != null)
                {
                    var parentOfUpper = this.currentDesign.getParentLayer(upperLayer);
                    if(parentOfUpper != null)
                    {
                        var upperIndex = parentOfUpper.getLayerIndex(upperLayer);
                        // レイヤーをいったん削除する
                        var deleteCommand = new DeleteLayerCommand(currentLayer, parent, this.currentDesign, () => {} );
                        this.currentDesign.undoRedoManager.doAsMultiCommand(deleteCommand, false);
                        // レイヤーを一つ上に追加する
                        var insertCommand = new InsertLayerCommand(currentLayer, parentOfUpper, upperIndex, this.currentDesign, () => {});
                        this.currentDesign.undoRedoManager.doAsMultiCommand(insertCommand, true);
                    }
                }
            }
            else
            {
                if(lowerLayer != null)
                {
                    var parentOfLower = this.currentDesign.getParentLayer(lowerLayer);
                    if(parentOfLower != null)
                    {
                        var lowerIndex = parentOfLower.getLayerIndex(lowerLayer);
                        // レイヤーをいったん削除する
                        var deleteCommand = new DeleteLayerCommand(currentLayer, parent, this.currentDesign, () => {} );
                        this.currentDesign.undoRedoManager.doAsMultiCommand(deleteCommand, false);
                        // レイヤーを一つ下に追加する
                        var insertCommand = new InsertLayerCommand(currentLayer, parentOfLower, lowerIndex, this.currentDesign, () => {});
                        this.currentDesign.undoRedoManager.doAsMultiCommand(insertCommand, true);
                    }
                }
            }
        }
    }

    // レイヤーのスケーリング
    private scaleLayer(layer : Layer, width : number, height : number, isFinish : boolean)
    {
        var srcCenterX = layer.centerX;
        var srcCenterY = layer.centerY;

        var command = new TransformLayerCommand(layer, layer.x, layer.y, width, height, layer.rotate, this.currentDesign, () => {});
        this.currentDesign.undoRedoManager.doAsMultiCommand(command, false);

        var dstCenterX = layer.centerX;
        var dstCenterY = layer.centerY;
        var tempCommand = new TransformLayerCommand(layer, layer.x - dstCenterX + srcCenterX, layer.y - dstCenterY + srcCenterY, layer.width, layer.height, layer.rotate, this.currentDesign, () => {});
        this.currentDesign.undoRedoManager.doAsMultiCommand(tempCommand, false);

        if(isFinish)
        {
            this.fixMultiCommand();
        }
    }

    private get currentTab() { return "/DesignEditor"; }

    isSubControllerVisible : boolean = true;


    closeSubController(){
        this.isSubControllerVisible = false;
        CookieHelper.setItem("isSubControllerVisible" , false)
    }

    openSubController(){
        this.isSubControllerVisible = true;
        CookieHelper.setItem("isSubControllerVisible" , true)
    }

    private closeLicense(){
        this.isLicense = false;
        this.isTutorial = CookieHelper.getItem("designEditorTutorial") != "true";
    }
}
